// Auto-generated product data
const images = {
  "Bullet/TNC-B210V12AFS": require("../views/Products/Bullet/img/TNC-B210V12AFS.png"),
  "Bullet/TNC-B217-V42AF": require("../views/Products/Bullet/img/TNC-B217-V42AF.png"),
  "Bullet/TNC-BZ204V12AFS": require("../views/Products/Bullet/img/TNC-BZ204V12AFS.png"),
  "Bullet/TNC-BZ236V12AF": require("../views/Products/Bullet/img/TNC-BZ236V12AF.png"),
  "Dome/TNC-D210V21AF": require("../views/Products/Dome/img/TNC-D210V21AF.png"),
  "Dome/TNC-D210V30AFS": require("../views/Products/Dome/img/TNC-D210V30AFS.png"),
  "Dome/TNC-FV120F": require("../views/Products/Dome/img/TNC-FV120F.png"),
  "Dome/TNC-V210F18": require("../views/Products/Dome/img/TNC-V210F18.png"),
  "Ptz/PTZ_1": require("../views/Products/Ptz/img/PTZ_1.jpg"),
  "Ptz/TNC-BP516AFS": require("../views/Products/Ptz/img/TNC-BP516AFS.png"),
  "Ptz/TNC-SPT2M-36AF": require("../views/Products/Ptz/img/TNC-SPT2M-36AF.png"),
  "Ptz/TNC-VS210AFS": require("../views/Products/Ptz/img/TNC-VS210AFS.png"),
  "Special/TNC-GB210V12AFS": require("../views/Products/Special/img/TNC-GB210V12AFS.png"),
  "Special/TNC-V210V06AF": require("../views/Products/Special/img/TNC-V210V06AF.png"),
  "SpeedDome/TNC-SD438AFS": require("../views/Products/SpeedDome/img/TNC-SD438AFS.png"),
  "SpeedDome/TNC-SD838AFS": require("../views/Products/SpeedDome/img/TNC-SD838AFS.png"),
};

export function getImage(key) {
  return images[key];
}

export const categories = [
  { key: "bullet", label: "Bullet", path: "/product/bullet" },
  { key: "dome", label: "Dome", path: "/product/dome" },
  { key: "speed-dome", label: "Speed Dome", path: "/product/speed-dome" },
  { key: "ptz", label: "PTZ", path: "/product/ptz" },
  { key: "special", label: "Special", path: "/product/special" },
];

export function getProductById(id) {
  return products.find((p) => p.id === id);
}

export function getProductsByCategory(category) {
  return products.filter((p) => p.category === category);
}

const products = [
  // TNC-B120V12AFS
  {
    id: "tnc-b120v12afs",
    isNew: true,
    model: "TNC-B120V12AFS",
    category: "bullet",
    categoryLabel: "Bullet",
    description: "12M Network IR Camera",
    aiSummary: "1200만 화소 고해상도 네트워크 적외선(IR) 불릿 카메라로, SONY CMOS 센서를 탑재해 선명한 영상을 제공합니다. 자동초점 줌 렌즈와 적외선/화이트 LED를 함께 지원하여 밤낮으로 선명한 감시가 가능하며, IP66 방진방수 등급으로 야외 환경에도 견고하게 사용할 수 있습니다.",
    allProductsImageKey: "Bullet/TNC-B210V12AFS",
    images: [
      { key: "Bullet/TNC-BZ236V12AF", isDefault: false },
      { key: "Bullet/TNC-B210V12AFS", isDefault: true },
      { key: "Bullet/TNC-B217-V42AF", isDefault: false },
      { key: "Bullet/TNC-BZ204V12AFS", isDefault: false },
    ],
    badges: [
      { text: "Network", colorScheme: "green" },
      { text: "IR", colorScheme: "red" },
      { text: "12M", colorScheme: "blue" },
    ],
    keyFeatures: [
      "12M 화소 네트워크 카메라(4000x3000P @ 20fps)",
      "H.265 / H.264 / MJPEG  Triple 스트리밍 지원",
      "1/2.3” SONY CMOS 이미지 센서 IMX412",
      "Built In AF ZOOM LENS (3.6~12mmAF)",
      "IR 제어 (850nm) +White led",
      "움직임 감지설정동작 및 외부 Sensor 감지시 만 White led 추가 동작",
      "WDR(Wide Dynamic Range)",
      "DNR(Digital Noise Reduction)",
      "양 뱡향 오디오 지원 ,ALARM IN &OUT",
      "FAN 내장 (내부 온도설정에 따른 자동 동작)",
      "IP66",
    ],
    specs: [
      { feature: "유효화소", value: "4000(H) x 3000 (V)(Full-HD)" },
      { feature: "촬상소자", value: "1/2.3“„ 12M Pixels Progressive Exmor Sensor" },
      { feature: "최소거리", value: "100mm~1200mm" },
      { feature: "S/N비", value: "54dB" },
      { feature: "최저조도", value: "0 Lux (IR LED ON)" },
      { feature: "초점 거리", value: "3.6 ~ 12mm Auto Focus // 6.0~22mmAF" },
      { feature: "초점 제어", value: "자동/수동 (네트워크를 통한 원격제어)" },
      { feature: "자동초점 (Auto Exposure)", value: "YES" },
      { feature: "디지털 줌", value: "8x" },
      { feature: "OSD", value: "Off/ON" },
      { feature: "Flip/Mirror", value: "Off/On" },
      { feature: "노출(AE)", value: "자동/수동" },
      { feature: "셔터속도", value: "1/10000 ~ 1/30 (sec)" },
      { feature: "자동 조리개", value: "Off/On" },
      { feature: "AuTo Flicker-less", value: "Off/On" },
      { feature: "색 온도(AWB)", value: "자동(실내,실외), 그늘, 쾌청한 하늘, 형광등, 백열등, 불꽃, 수동" },
      { feature: "Day & NighT", value: "자동/주간/야간/외부신호" },
      { feature: "WDR,BLC,HLC,DNR", value: "Off/On" },
      { feature: "안개보정(Defog)", value: "Off/On/Auto" },
      { feature: "세로모드", value: "Off/On (90도, 270도)" },
      { feature: "LDC 경계선", value: "Off/On" },
      { feature: "사생활 보호(Privacy Mask)", value: "8개 영역 지정가능" },
      { feature: "움직임 감지(MoTion DeTecTion)", value: "4개 Mask, 4개 DeTecTion 지정가능" },
      { feature: "이벤트 감지", value: "알람 입력,부팅감지,수동 트리거,네트워크감지" },
      { feature: "이벤트 동작", value: "알람 출력" },
      { feature: "화면 가림 감지(Temper)", value: "Off/On" },
      { feature: "야간가시거리", value: "70~100m(IR LED : 8개) WHITE LED 2개" },
      { feature: "비디오 압축방식", value: "H.264/H265(High, Main ,Baseline Profile), MJPEG" },
      { feature: "비디오 해상도", value: "4000X3000, 3840X2160, 2592X1944, 2048X1536, 1920x1080, 1280x1024, 1280x720, 704x576, 704x480, 640x480, 640x360, 320x240" },
      { feature: "최대 프레임 레이트", value: "최대 20fps@4000 x 3000" },
      { feature: "오디오 압축방식", value: "G.711 ADPCM a-Law/u-Law" },
      { feature: "통신 양방향 입력(opTion)", value: "1Line-In" },
      { feature: "통신 양방향 출력(opTion)", value: "1Line-OuT" },
      { feature: "네트 워크 이더넷", value: "RJ-45(10/100BASE-T)" },
      { feature: "네트 워크 비트 레이트", value: "100 ~ 12000Kbps" },
      { feature: "네트 워크 IP", value: "IPv4, IPv6" },
      { feature: "네트 워크 ProTocol", value: "TCP/IP,UDP/IP,RTP,RTSP,HTTP,HTTPS,SMTP,FTP,DHCP,UPnP ,Zeroconf, DNS,DDNS" },
      { feature: "보안", value: "HTTPS암호화,사용자 관리, IP주소 필터링" },
      { feature: "FTP Uploading", value: "MJPEG STil Image" },
      { feature: "최대 동시 접속자", value: "10" },
      { feature: "S/W 응용 인터페이스", value: "Onvif profile S, ..." },
      { feature: "웹 뷰어 지원OS", value: "Windows VisTa(32biT)/7/8" },
      { feature: "웹 뷰어 지원 웹브라우져", value: "Micro Internet Explorer Ver.9, 10 Apple Safari Ver.4.0(Plug-in free viewer only) Google Chrome Ver.4.0(Plug-in free viewer only)" },
      { feature: "웹 언어", value: "한국어, English, 러시아어,일본어" },
      { feature: "일반 동작온도/습도", value: "-20°C ~ 50°C / 90% RH 이하" },
      { feature: "일반 방진/방수", value: "IP66" },
      { feature: "일반 조절", value: "Y" },
      { feature: "일반 사용전원/소비전류", value: "DC12V, PoE(IEEE802.3af) / 1A(Max)" },
      { feature: "일반 재질/색상", value: "Aluminum / black / white" },
      { feature: "일반 중량", value: "1.5 Kg" },
      { feature: "일반 외 형 치 수", value: "85.7mm(W) X93mm(H)X297 mm(L)/ 75pi X 297(L)" },
      ],
    relatedProducts: [
      { id: "tnc-bz236v12af", badges: ["Network","IR","2M"] },
      { id: "tnc-bz204v12afs", badges: ["Network","IR","2M"] },
      { id: "tnc-b210v12afs", badges: ["Network","IR","2M"] },
      { id: "tnc-b510v12af", badges: ["Network","IR","5M"] },
      { id: "utc-8060r", badges: ["UTC","IR","4K 8M"] },
      { id: "tnc-bf228afs", badges: ["Network","IR","2M","Fire Alarm"] },
      { id: "tnc-bf528af", badges: ["Network","IR","5M","Fire Alarm"] },
    ],
  },
  // TNC-B210V12AFS
  {
    id: "tnc-b210v12afs",
    model: "TNC-B210V12AFS",
    category: "bullet",
    categoryLabel: "Bullet",
    description: "2M Network IR Camera",
    aiSummary: "200만 화소 풀HD 네트워크 적외선(IR) 불릿 카메라로, 최대 60fps의 부드러운 영상을 제공합니다. SONY 고성능 센서와 자동초점 줌 렌즈를 탑재하고 있으며, 적외선 야간 가시거리 최대 120m까지 지원해 어두운 환경에서도 안정적인 감시가 가능합니다.",
    allProductsImageKey: "Bullet/TNC-B210V12AFS",
    images: [
      { key: "Bullet/TNC-BZ236V12AF", isDefault: false },
      { key: "Bullet/TNC-B210V12AFS", isDefault: true },
      { key: "Bullet/TNC-B217-V42AF", isDefault: false },
      { key: "Bullet/TNC-BZ204V12AFS", isDefault: false },
    ],
    badges: [
      { text: "Network", colorScheme: "green" },
      { text: "IR", colorScheme: "red" },
      { text: "2M", colorScheme: "blue" },
    ],
    keyFeatures: [
      "200만 화소 네트워크 카메라(1920x1080P @ 60fps)",
      "H.265 / H.264 / MJPEG  Triple 스트리밍 지원",
      "1/2” SONY CMOS 이미지 센서_IMX385",
      "Built In AF ZOOM LENS (3.6~12mmAF)",
      "IR 제어 (850nm) +White led",
      "움직임 감지설정동작 및 외부 Sensor 감지시 만 White led 추가 동작 기능",
      "양 뱡향 오디오 지원 ,ALARM IN &OUT",
      "FAN 내장 (내부 온도설정에 따른 자동 동작)",
      "IP66",
    ],
    specs: [
      { feature: "유효화소", value: "1920(H) x 1080(V)(Full-HD)" },
      { feature: "촬상소자", value: "1/2\" 2.1M Pixels Progressive Exmor Sensor" },
      { feature: "최소거리", value: "100mm~1200mm" },
      { feature: "S/N비", value: "54dB" },
      { feature: "최저조도", value: "0 Lux (IR LED ON)" },
      { feature: "초점 거리", value: "f=3.6mm ~ 12mm AF / 6.0~22mmAF" },
      { feature: "초점 제어", value: "자동/수동 (네트워크를 통한 원격제어)" },
      { feature: "자동초점 (AuTo Exposure)", value: "YES" },
      { feature: "디지털 줌", value: "8x" },
      { feature: "OSD", value: "Off/ON" },
      { feature: "Flip/Mirror", value: "Off/On" },
      { feature: "노출(AE)", value: "자동/수동" },
      { feature: "셔터속도", value: "1/10000 ~ 1/30 (sec)" },
      { feature: "자동 조리개", value: "Off/On" },
      { feature: "AuTo Flicker-less", value: "Off/On" },
      { feature: "색 온도(AWB)", value: "자동(실내,실외), 그늘, 쾌청한 하늘, 형광등, 백열등, 불꽃, 수동" },
      { feature: "Day & NighT", value: "자동/주간/야간/외부신호" },
      { feature: "WDR,BLC,HLC,DNR", value: "Off/On" },
      { feature: "안개보정(Defog)", value: "Off/On/AuTo" },
      { feature: "세로모드", value: "Off/On (90도, 270도)" },
      { feature: "LDC 경계선", value: "Off/On" },
      { feature: "사생활 보호(Privacy Mask)", value: "8개 영역 지정가능" },
      { feature: "움직임 감지(MoTion DeTecTion)", value: "4개 Mask, 4개 DeTecTion 지정가능" },
      { feature: "이벤트 감지", value: "알람 입력,부팅감지,수동 트리거,네트워크감지" },
      { feature: "이벤트 동작", value: "알람 출력" },
      { feature: "화면 가림 감지(Temper)", value: "Off/On" },
      { feature: "야간가시거리", value: "70~120m(ISUPER R LED : 8개) WHITE LED 2~4개" },
      { feature: "비디오 압축방식", value: "H.264/H265(High, Main ,Baseline Profile), MJPEG" },
      { feature: "비디오 해상도", value: "1920x1080, 1280x1024, 1280x720, 704x576, 704x480, 640x480, 640x360, 320x240" },
      { feature: "최대 프레임 레이트", value: "최대 60fps@ 1920x1080" },
      { feature: "오디오 압축방식", value: "G.711 ADPCM a-Law/u-Law" },
      { feature: "통신 양방향 입력(opTion)", value: "1Line-In" },
      { feature: "통신 양방향 출력(opTion)", value: "1Line-OuT" },
      { feature: "네트 워크 이더넷", value: "RJ-45(10/100BASE-T)" },
      { feature: "네트 워크 비트 레이트", value: "100 ~ 12000Kbps" },
      { feature: "네트 워크 IP", value: "IPv4, IPv6" },
      { feature: "네트 워크 ProTocol", value: "TCP/IP,UDP/IP,RTP,RTSP,HTTP,HTTPS,SMTP,FTP,DHCP,UPnP ,Zeroconf, DNS,DDNS" },
      { feature: "보안", value: "HTTPS암호화,사용자 관리, IP주소 필터링" },
      { feature: "FTP Uploading", value: "MJPEG STil Image" },
      { feature: "최대 동시 접속자", value: "10" },
      { feature: "S/W 응용 인터페이스", value: "Onvif profile S, ..." },
      { feature: "웹 뷰어 지원OS", value: "Windows VisTa(32biT)/7/8" },
      { feature: "웹 뷰어 지원 웹브라우져", value: "Micro InTerneT Explorer Ver.9, 10 Apple Safari Ver.4.0(Plug-in free viewer only) Google Chrome Ver.4.0(Plug-in free viewer only)" },
      { feature: "웹 언어", value: "한국어, English, 러시아어,일본어" },
      { feature: "일반 동작온도/습도", value: "-20°C ~ 50°C / 90% RH 이하" },
      { feature: "일반 방진/방수", value: "IP66" },
      { feature: "일반 조절", value: "Y" },
      { feature: "일반 사용전원/소비전류", value: "DC12V, PoE(IEEE802.3af) / 1A(Max)" },
      { feature: "일반 재질/색상", value: "Aluminum / Dark gray / white" },
      { feature: "일반 중량", value: "1.5 Kg" },
      { feature: "일반 외 형 치 수", value: "85.7mm(W) X93mm(H)X297 mm(L)_75pi" },
      ],
    relatedProducts: [
      { id: "tnc-bz236v12af", badges: ["Network","IR","2M"] },
      { id: "tnc-bz204v12afs", badges: ["Network","IR","2M"] },
      { id: "tnc-b510v12af", badges: ["Network","IR","5M"] },
      { id: "tnc-b120v12afs", badges: ["Network","IR","12M"] },
      { id: "utc-8060r", badges: ["UTC","IR","4K 8M"] },
      { id: "tnc-bf228afs", badges: ["Network","IR","2M","Fire Alarm"] },
      { id: "tnc-bf528af", badges: ["Network","IR","5M","Fire Alarm"] },
    ],
  },
  // TNC-B510V12AF
  {
    id: "tnc-b510v12af",
    isNew: true,
    model: "TNC-B510V12AF",
    category: "bullet",
    categoryLabel: "Bullet",
    description: "5M Network IR Camera",
    aiTags: ["object-detection"],
    aiSummary: "500만 화소 고해상도 네트워크 적외선(IR) 불릿 카메라로, 다양한 해상도 옵션을 지원합니다. 넓은 화각의 줌 렌즈와 객체분석 기능을 갖추고 있어, 세밀한 식별이 필요한 주차장, 창고, 건물 외곽 등 중거리 감시에 적합합니다.",
    allProductsImageKey: "Bullet/TNC-B210V12AFS",
    images: [
      { key: "Bullet/TNC-BZ236V12AF", isDefault: false },
      { key: "Bullet/TNC-B210V12AFS", isDefault: true },
      { key: "Bullet/TNC-B217-V42AF", isDefault: false },
      { key: "Bullet/TNC-BZ204V12AFS", isDefault: false },
    ],
    badges: [
      { text: "Network", colorScheme: "green" },
      { text: "IR", colorScheme: "red" },
      { text: "5M", colorScheme: "blue" },
    ],
    keyFeatures: [
      "500만 화소 네트워크 카메라(2592x1944P @ 30fps)   // 3M / 4M 제품 지원가능 (옵션)",
      "H.265 / H.264 / MJPEG  Triple 스트리밍 지원",
      "1/2.8” SONY CMOS 이미지 센서_IMX335",
      "Built In AF ZOOM LENS (2.7~13.5mmAF)",
      "IR 제어 (850nm) +White led",
      "움직임 감지설정동작 (객체분석)  및 외부 Sensor 감지시 만 White led 추가 동작 기능",
      "WDR(Wide Dynamic Range)",
      "DNR(Digital Noise Reduction)",
      "양 뱡향 오디오 지원 ,ALARM IN &OUT",
      "FAN 내장 (내부 온도설정에 따른 자동 동작)",
      "IP66",
    ],
    specs: [
      { feature: "유효화소", value: "2704(H) x 2104(V)" },
      { feature: "촬상소자", value: "1/2.8„5.6M Pixels Progressive Exmor Sensor" },
      { feature: "최소거리", value: "100mm~1200mm" },
      { feature: "S/N비", value: "54dB" },
      { feature: "최저조도", value: "0 Lux (IR LED ON)" },
      { feature: "초점 거리", value: "f=2.7mm ~ 13.5mm AF / 5.0~50mmAF (옵션)" },
      { feature: "초점 제어", value: "자동/수동 (네트워크를 통한 원격제어)" },
      { feature: "자동초점 (AuTo Exposure)", value: "YES" },
      { feature: "디지털 줌", value: "8x" },
      { feature: "OSD", value: "Off/ON" },
      { feature: "Flip/Mirror", value: "Off/On" },
      { feature: "노출(AE)", value: "자동/수동" },
      { feature: "셔터속도", value: "1/10000 ~ 1/30 (sec)" },
      { feature: "자동 조리개", value: "Off/On" },
      { feature: "AuTo Flicker-less", value: "Off/On" },
      { feature: "색 온도(AWB)", value: "자동(실내,실외), 그늘, 쾌청한 하늘, 형광등, 백열등, 불꽃, 수동" },
      { feature: "Day & NighT", value: "자동/주간/야간/외부신호" },
      { feature: "WDR,BLC,HLC,DNR", value: "Off/On" },
      { feature: "안개보정(Defog)", value: "Off/On/AuTo" },
      { feature: "세로모드", value: "Off/On (90도, 270도)" },
      { feature: "LDC 경계선", value: "Off/On" },
      { feature: "사생활 보호(Privacy Mask)", value: "8개 영역 지정가능" },
      { feature: "움직임 감지(MoTion DeTecTion)", value: "4개 Mask, 4개 DeTecTion 지정가능" },
      { feature: "이벤트 감지", value: "알람 입력,부팅감지,수동 트리거,네트워크감지" },
      { feature: "이벤트 동작", value: "알람 출력" },
      { feature: "화면 가림 감지(Temper)", value: "Off/On" },
      { feature: "야간가시거리", value: "70~100m(IR LED : 8개WHITE LED 2개~4개" },
      { feature: "비디오 압축방식", value: "H.264/H265(High, Main ,Baseline Profile), MJPEG" },
      { feature: "비디오 해상도", value: "2592X1944, 2048X1536, 1920x1080, 1280x1024, 1280x720, 704x576, 704x480, 640x480, 640x360, 320x240" },
      { feature: "최대 프레임 레이트", value: "최대 30fps@ 2592x1944" },
      { feature: "오디오 압축방식", value: "G.711 ADPCM a-Law/u-Law" },
      { feature: "통신 양방향 입력(opTion)", value: "1Line-In" },
      { feature: "통신 양방향 출력(opTion)", value: "1Line-OuT" },
      { feature: "네트 워크 이더넷", value: "RJ-45(10/100BASE-T)" },
      { feature: "네트 워크 비트 레이트", value: "100 ~ 12000Kbps" },
      { feature: "네트 워크 IP", value: "IPv4, IPv6" },
      { feature: "네트 워크 ProTocol", value: "TCP/IP,UDP/IP,RTP,RTSP,HTTP,HTTPS,SMTP,FTP,DHCP,UPnP ,Zeroconf, DNS,DDNS" },
      { feature: "보안", value: "HTTPS암호화,사용자 관리, IP주소 필터링" },
      { feature: "FTP Uploading", value: "MJPEG STil Image" },
      { feature: "최대 동시 접속자", value: "10" },
      { feature: "S/W 응용 인터페이스", value: "Onvif profile S, ..." },
      { feature: "웹 뷰어 지원OS", value: "Windows VisTa(32biT)/7/8" },
      { feature: "웹 뷰어 지원 웹브라우져", value: "Micro Internet Explorer Ver.9, 10 Apple Safari Ver.4.0(Plug-in free viewer only) Google Chrome Ver.4.0(Plug-in free viewer only)" },
      { feature: "웹 언어", value: "한국어, English, 러시아어,일본어" },
      { feature: "일반 동작온도/습도", value: "-20°C ~ 50°C / 90% RH 이하" },
      { feature: "일반 방진/방수", value: "IP66" },
      { feature: "일반 조절", value: "Y" },
      { feature: "일반 사용전원/소비전류", value: "DC12V, PoE(IEEE802.3af) / 1A(Max)" },
      { feature: "일반 재질/색상", value: "Aluminum / black / white" },
      { feature: "일반 중량", value: "1.5 Kg" },
      { feature: "일반 외 형 치 수", value: "85.7mm(W) X93mm(H)X297 mm(L)/ 75pi X 297(L)" },
      ],
    relatedProducts: [
      { id: "tnc-bz236v12af", badges: ["Network","IR","2M"] },
      { id: "tnc-bz204v12afs", badges: ["Network","IR","2M"] },
      { id: "tnc-b210v12afs", badges: ["Network","IR","2M"] },
      { id: "tnc-b120v12afs", badges: ["Network","IR","12M"] },
      { id: "utc-8060r", badges: ["UTC","IR","4K 8M"] },
      { id: "tnc-bf228afs", badges: ["Network","IR","2M","Fire Alarm"] },
      { id: "tnc-bf528af", badges: ["Network","IR","5M","Fire Alarm"] },
    ],
  },
  // TNC-BF228AFS
  {
    id: "tnc-bf228afs",
    isNew: true,
    model: "TNC-BF228AFS",
    category: "bullet",
    categoryLabel: "Bullet",
    description: "2M Network Fire Alarm IR Camera",
    aiSummary: "200만 화소 네트워크 적외선(IR) 불릿 카메라에 3파장 화염 감지 센서를 결합한 화재감지 전용 카메라입니다. SONY STARVIS 고감도 센서와 사파이어 렌즈를 장착해 열악한 환경에서도 안정적으로 화재를 감지할 수 있습니다.",
    allProductsImageKey: "Bullet/TNC-B210V12AFS",
    images: [
      { key: "Bullet/TNC-BZ236V12AF", isDefault: false },
      { key: "Bullet/TNC-B210V12AFS", isDefault: true },
      { key: "Bullet/TNC-B217-V42AF", isDefault: false },
      { key: "Bullet/TNC-BZ204V12AFS", isDefault: false },
    ],
    badges: [
      { text: "Fire Alarm", colorScheme: "yellow" },
      { text: "Network", colorScheme: "green" },
      { text: "IR", colorScheme: "red" },
      { text: "2M", colorScheme: "blue" },
    ],
    keyFeatures: [
      "200만 화소 네트워크 카메라(1920x1980P @ 60fps)",
      "H.265 / H.264 / MJPEG  Triple 스트리밍 지원",
      "1/ 2” SONY STARVIS고감도 센서  IMX385",
      "Built In AFZOOM  LENS  (3.6~12mmAF)",
      "Sapphire Lens 장착",
      "양 뱡향 오디오 ,ALARM OUT지원",
      "IP66",
    ],
    specs: [
      { feature: "유효화소", value: "1952(H) x 1113(V)" },
      { feature: "촬상소자", value: "1/2\" 2M Pixels Progressive Exmor Sensor" },
      { feature: "최소거리", value: "100mm~1200mm" },
      { feature: "S/N비", value: "54dB" },
      { feature: "최저조도", value: "0 Lux (IR LED ON)" },
      { feature: "초점 거리", value: "f=3.6mm ~ 12mm AF // 3.6mm, 6mm (옵션)" },
      { feature: "초점 제어", value: "자동/수동 (네트워크를 통한 원격제어)" },
      { feature: "자동초점 (Auto Exposure)", value: "YES" },
      { feature: "디지털 줌", value: "8x" },
      { feature: "OSD", value: "Off/On" },
      { feature: "Flip/Mirror", value: "Off/On" },
      { feature: "노출(AE)", value: "자동/수동" },
      { feature: "셔터속도", value: "1/10000 ~ 1/30 (sec)" },
      { feature: "자동 조리개", value: "Off/On" },
      { feature: "Auto Flicker-less", value: "Off/On" },
      { feature: "색 온도(AWB)", value: "자동(실내, 실외), 그늘, 쾌청한 하늘, 형광등, 백열등, 불꽃, 수동" },
      { feature: "Day & Night", value: "자동/주간/야간/외부신호" },
      { feature: "WDR, BLC, HLC, DNR", value: "Off/On" },
      { feature: "안개보정(Defog)", value: "Off/On/Auto" },
      { feature: "세로모드", value: "Off/On (90도, 270도)" },
      { feature: "LDC 경계선", value: "Off/On" },
      { feature: "사생활 보호(Privacy Mask)", value: "8개 영역 지정가능" },
      { feature: "움직임 감지(Motion Detection)", value: "4개 Mask, 4개 Detection 지정가능" },
      { feature: "이벤트 감지", value: "부팅감지, 수동 트리거, 네트워크감지" },
      { feature: "이벤트 동작", value: "알람 출력" },
      { feature: "화재감지 기능", value: "3파장 Flame Sensor (3900nm, 4300nm, 5100nm)" },
      { feature: "야간가시거리", value: "IR SUPER LED: 8개 / Flame Sensor" },
      { feature: "압축방식", value: "H.264/H265(High, Main, Baseline Profile), MJPEG" },
      { feature: "해상도", value: "1920x1080, 1280x1024, 1280x720, 704x576, 704x480, 640x480, 640x360, 320x240" },
      { feature: "최대 프레임 레이트", value: "최대 60fps@1920x1080" },
      { feature: "압축방식", value: "G.711 ADPCM a-Law/u-Law" },
      { feature: "양방향 입력(option)", value: "1Line-In" },
      { feature: "양방향 출력(option)", value: "1Line-Out" },
      { feature: "이더넷", value: "RJ-45(10/100BASE-T)" },
      { feature: "비트 레이트", value: "100 ~ 12000Kbps" },
      { feature: "IP", value: "IPv4, IPv6" },
      { feature: "Protocol", value: "TCP/IP, UDP/IP, RTP, RTSP, HTTP, HTTPS, SMTP, FTP, DHCP, UPnP, Zeroconf, DNS, DDNS" },
      { feature: "보안", value: "HTTPS 암호화, 사용자 관리, IP 주소 필터링" },
      { feature: "FTP Uploading", value: "MJPEG Still Image" },
      { feature: "최대 동시 접속자", value: "10" },
      { feature: "S/W 응용 인터페이스", value: "Onvif profile S, ..." },
      { feature: "지원 OS", value: "Windows Vista(32bit)/7/8" },
      { feature: "지원 웹브라우저", value: "Micro Internet Explorer Ver.9, 10 Apple Safari Ver.4.0 (Plug-in free viewer only) Google Chrome Ver.4.0 (Plug-in free viewer only)" },
      { feature: "웹 언어", value: "한국어, English, 러시아어, 일본어" },
      { feature: "동작온도/습도", value: "-20°C ~ 50°C / 90% RH 이하" },
      { feature: "방진/방수", value: "IP66" },
      { feature: "조절", value: "Y" },
      { feature: "사용전원/소비전류", value: "DC12V, PoE(IEEE802.3af) / 3.0 A(Max)" },
      { feature: "재질/색상", value: "Aluminum / Dark gray / White" },
      { feature: "중량", value: "1.0 Kg" },
      { feature: "외형 치수", value: "85.7mm(W) x 93mm(H) x 297mm(L)_93pi" },
      ],
    relatedProducts: [
      { id: "tnc-bf528af", badges: ["Network","IR","5M","Fire Alarm"] },
      { id: "tnc-bz236v12af", badges: ["Network","IR","2M"] },
      { id: "tnc-bz204v12afs", badges: ["Network","IR","2M"] },
      { id: "tnc-b210v12afs", badges: ["Network","IR","2M"] },
      { id: "tnc-b510v12af", badges: ["Network","IR","5M"] },
      { id: "tnc-b120v12afs", badges: ["Network","IR","12M"] },
      { id: "utc-8060r", badges: ["UTC","IR","4K 8M"] },
    ],
  },
  // TNC-BF528AF
  {
    id: "tnc-bf528af",
    isNew: true,
    model: "TNC-BF528AF",
    category: "bullet",
    categoryLabel: "Bullet",
    description: "5M Network Fire Alarm IR Camera",
    aiSummary: "500만 화소 네트워크 적외선(IR) 불릿 카메라에 듀얼 화염 감지 센서를 결합한 고해상도 화재감지 전용 카메라입니다. 고해상도 영상과 화재 감지 기능을 동시에 제공하여, 대형 공장, 에너지 시설, 임야 등 화재 감시와 일반 보안 감시를 동시에 수행해야 하는 환경에 최적화되어 있습니다.",
    allProductsImageKey: "Bullet/TNC-B210V12AFS",
    images: [
      { key: "Bullet/TNC-BZ236V12AF", isDefault: false },
      { key: "Bullet/TNC-B210V12AFS", isDefault: true },
      { key: "Bullet/TNC-B217-V42AF", isDefault: false },
      { key: "Bullet/TNC-BZ204V12AFS", isDefault: false },
    ],
    badges: [
      { text: "Fire Alarm", colorScheme: "yellow" },
      { text: "Network", colorScheme: "green" },
      { text: "IR", colorScheme: "red" },
      { text: "5M", colorScheme: "blue" },
    ],
    keyFeatures: [
      "500만 화소 네트워크 카메라(2592x1944P @ 30fps)",
      "H.265 / H.264 / MJPEG  Triple 스트리밍 지원",
      "1/ 2.8” SONY STARVIS고감도 센서  IMX335",
      "2.8~12mmAF / 3.6mm (옵션)",
      "Sapphire Lens 장착",
      "양 뱡향 오디오 ,ALARM OUT지원",
      "IP66",
    ],
    specs: [
      { feature: "유효화소", value: "2592(H) x 1944(V)" },
      { feature: "촬상소자", value: "1/2.8\" 2M Pixels Progressive Exmor Sensor" },
      { feature: "최소거리", value: "100mm~1200mm" },
      { feature: "S/N비", value: "54dB" },
      { feature: "최저조도", value: "0 Lux (IR LED ON)" },
      { feature: "초점 거리", value: "f=2.8mm ~ 12mm AF / 3.6mm (옵션)" },
      { feature: "초점 제어", value: "자동/수동 (네트워크를 통한 원격제어)" },
      { feature: "자동초점 (Auto Exposure)", value: "YES" },
      { feature: "디지털 줌", value: "8x" },
      { feature: "OSD", value: "Off/On" },
      { feature: "Flip/Mirror", value: "Off/On" },
      { feature: "노출(AE)", value: "자동/수동" },
      { feature: "셔터속도", value: "1/10000 ~ 1/30 (sec)" },
      { feature: "자동 조리개", value: "Off/On" },
      { feature: "Auto Flicker-less", value: "Off/On" },
      { feature: "색 온도(AWB)", value: "자동(실내, 실외), 그늘, 쾌청한 하늘, 형광등, 백열등, 불꽃, 수동" },
      { feature: "Day & Night", value: "자동/주간/야간/외부신호" },
      { feature: "WDR, BLC, HLC, DNR", value: "Off/On" },
      { feature: "안개보정(Defog)", value: "Off/On/Auto" },
      { feature: "세로모드", value: "Off/On (90도, 270도)" },
      { feature: "LDC 경계선", value: "Off/On" },
      { feature: "사생활 보호(Privacy Mask)", value: "8개 영역 지정가능" },
      { feature: "움직임 감지(Motion Detection)", value: "4개 Mask, 4개 Detection 지정가능" },
      { feature: "이벤트 감지", value: "부팅감지, 수동 트리거, 네트워크감지" },
      { feature: "이벤트 동작", value: "알람 출력" },
      { feature: "화재감지 기능", value: "DUAL Flame Sensor (3900nm, 4300nm)" },
      { feature: "야간가시거리", value: "IR SUPER LED: 8개 / Flame Sensor" },
      { feature: "압축방식", value: "H.264/H265(High, Main, Baseline Profile), MJPEG" },
      { feature: "해상도", value: "2592x1944, 2048x1536, 1920x1080, 1280x1024, 1280x720, 704x576, 704x480, 640x480, 640x360, 320x240" },
      { feature: "최대 프레임 레이트", value: "최대 30fps@2592x1944" },
      { feature: "압축방식", value: "G.711 ADPCM a-Law/u-Law" },
      { feature: "양방향 입력(option)", value: "1Line-In" },
      { feature: "양방향 출력(option)", value: "1Line-Out" },
      { feature: "이더넷", value: "RJ-45(10/100BASE-T)" },
      { feature: "비트 레이트", value: "100 ~ 12000Kbps" },
      { feature: "IP", value: "IPv4, IPv6" },
      { feature: "Protocol", value: "TCP/IP, UDP/IP, RTP, RTSP, HTTP, HTTPS, SMTP, FTP, DHCP, UPnP, Zeroconf, DNS, DDNS" },
      { feature: "보안", value: "HTTPS 암호화, 사용자 관리, IP 주소 필터링" },
      { feature: "FTP Uploading", value: "MJPEG Still Image" },
      { feature: "최대 동시 접속자", value: "10" },
      { feature: "S/W 응용 인터페이스", value: "Onvif profile S, ..." },
      { feature: "지원 OS", value: "Windows Vista(32bit)/7/8" },
      { feature: "지원 웹브라우저", value: "Micro Internet Explorer Ver.9, 10 Apple Safari Ver.4.0 (Plug-in free viewer only) Google Chrome Ver.4.0 (Plug-in free viewer only)" },
      { feature: "웹 언어", value: "한국어, English, 러시아어, 일본어" },
      { feature: "동작온도/습도", value: "-20°C ~ 50°C / 90% RH 이하" },
      { feature: "방진/방수", value: "IP66" },
      { feature: "조절", value: "Y" },
      { feature: "사용전원/소비전류", value: "DC12V, PoE(IEEE802.3af) / 3.0 A(Max)" },
      { feature: "재질/색상", value: "Aluminum / Dark gray / White" },
      { feature: "중량", value: "1.0 Kg" },
      { feature: "외형 치수", value: "85.7mm(W) x 93mm(H) x 297mm(L)_93pi" },
      ],
    relatedProducts: [
      { id: "tnc-bf228afs", badges: ["Network","IR","2M","Fire Alarm"] },
      { id: "tnc-bz236v12af", badges: ["Network","IR","2M"] },
      { id: "tnc-bz204v12afs", badges: ["Network","IR","2M"] },
      { id: "tnc-b210v12afs", badges: ["Network","IR","2M"] },
      { id: "tnc-b510v12af", badges: ["Network","IR","5M"] },
      { id: "tnc-b120v12afs", badges: ["Network","IR","12M"] },
      { id: "utc-8060r", badges: ["UTC","IR","4K 8M"] },
    ],
  },
  // TNC-BZ204V12AFS
  {
    id: "tnc-bz204v12afs",
    model: "TNC-BZ204V12AFS",
    category: "bullet",
    categoryLabel: "Bullet",
    description: "2M Network IR Camera",
    aiSummary: "200만 화소 네트워크 적외선(IR) 불릿 카메라로, 4배율 자동초점 줌 렌즈를 장착한 줌 특화 모델입니다. 최대 60fps의 부드러운 영상과 적외선/화이트 LED를 지원하며, 원거리 감시가 필요한 주차장, 도로, 펜스 라인 등 중거리 보안 감시에 적합합니다.",
    allProductsImageKey: "Bullet/TNC-BZ204V12AFS",
    images: [
      { key: "Bullet/TNC-BZ236V12AF", isDefault: false },
      { key: "Bullet/TNC-B210V12AFS", isDefault: false },
      { key: "Bullet/TNC-B217-V42AF", isDefault: false },
      { key: "Bullet/TNC-BZ204V12AFS", isDefault: true },
    ],
    badges: [
      { text: "Network", colorScheme: "green" },
      { text: "IR", colorScheme: "red" },
      { text: "2M", colorScheme: "blue" },
    ],
    keyFeatures: [
      "200만 화소 네트워크 카메라(1920x1080P @ 60fps)",
      "H.265 / H.264 / MJPEG  Triple 스트리밍 지원",
      "1/2” SONY CMOS 이미지 센서_IMX385",
      "Built In X4 AF 전용 ZOOM LENS (3.5~14mmAF)",
      "IR 제어 (850nm) +White led",
      "움직임 감지설정동작  및 외부 Sensor 감지시 만White led 추가 동작 기능",
      "WDR(Wide Dynamic Range)",
      "DNR(Digital Noise Reduction)",
      "움직임 감지 기능",
      "양 뱡향 오디오 지원 ,ALARM IN &OUT",
      "FAN 내장 (내부 온도설정에 따른 자동 동작)",
      "IP66",
    ],
    specs: [
      { feature: "유효화소", value: "1920(H) x 1080(V)(Full-HD)" },
      { feature: "촬상소자", value: "1/2\" 2.1M Pixels Progressive Exmor Sensor" },
      { feature: "최소거리", value: "100mm~1200mm" },
      { feature: "S/N비", value: "54dB" },
      { feature: "최저조도", value: "0 Lux (IR LED ON)" },
      { feature: "초점 거리", value: "f=3.5mm ~ 14mm AF" },
      { feature: "초점 제어", value: "자동/수동 (네트워크를 통한 원격제어)" },
      { feature: "자동초점 (AuTo Exposure)", value: "YES" },
      { feature: "디지털 줌", value: "8x" },
      { feature: "OSD", value: "Off/ON" },
      { feature: "Flip/Mirror", value: "Off/On" },
      { feature: "노출(AE)", value: "자동/수동" },
      { feature: "셔터속도", value: "1/10000 ~ 1/30 (sec)" },
      { feature: "자동 조리개", value: "Off/On" },
      { feature: "AuTo Flicker-less", value: "Off/On" },
      { feature: "색 온도(AWB)", value: "자동(실내,실외), 그늘, 쾌청한 하늘, 형광등, 백열등, 불꽃, 수동" },
      { feature: "Day & NighT", value: "자동/주간/야간/외부신호" },
      { feature: "WDR,BLC,HLC,DNR", value: "Off/On" },
      { feature: "안개보정(Defog)", value: "Off/On/AuTo" },
      { feature: "세로모드", value: "Off/On (90도, 270도)" },
      { feature: "LDC 경계선", value: "Off/On" },
      { feature: "사생활 보호(Privacy Mask)", value: "8개 영역 지정가능" },
      { feature: "움직임 감지(MoTion DeTecTion)", value: "4개 Mask, 4개 DeTecTion 지정가능" },
      { feature: "이벤트 감지", value: "알람 입력,부팅감지,수동 트리거,네트워크감지" },
      { feature: "이벤트 동작", value: "알람 출력" },
      { feature: "화면 가림 감지(Temper)", value: "Off/On" },
      { feature: "야간가시거리", value: "70~100m(IR LED : 8개) W/ WHITE LED 2~4개" },
      { feature: "비디오 압축방식", value: "H.264/H265(High, Main ,Baseline Profile), MJPEG" },
      { feature: "비디오 해상도", value: "1920x1080, 1280x1024, 1280x720, 704x576, 704x480, 640x480, 640x360, 320x240" },
      { feature: "최대 프레임 레이트", value: "최대 60fps@ 1920x1080" },
      { feature: "오디오 압축방식", value: "G.711 ADPCM a-Law/u-Law" },
      { feature: "통신 양방향 입력(opTion)", value: "1Line-In" },
      { feature: "통신 양방향 출력(opTion)", value: "1Line-OuT" },
      { feature: "네트 워크 이더넷", value: "RJ-45(10/100BASE-T)" },
      { feature: "네트 워크 비트 레이트", value: "100 ~ 12000Kbps" },
      { feature: "네트 워크 IP", value: "IPv4, IPv6" },
      { feature: "네트 워크 ProTocol", value: "TCP/IP,UDP/IP,RTP,RTSP,HTTP,HTTPS,SMTP,FTP,DHCP,UPnP ,Zeroconf, DNS,DDNS" },
      { feature: "보안", value: "HTTPS암호화,사용자 관리, IP주소 필터링" },
      { feature: "FTP Uploading", value: "MJPEG STil Image" },
      { feature: "최대 동시 접속자", value: "10" },
      { feature: "S/W 응용 인터페이스", value: "Onvif profile S, ..." },
      { feature: "웹 뷰어 지원OS", value: "Windows VisTa(32biT)/7/8" },
      { feature: "웹 뷰어 지원 웹브라우져", value: "Micro Internet Explorer Ver.9, 10 Apple Safari Ver.4.0(Plug-in free viewer only) Google Chrome Ver.4.0(Plug-in free viewer only)" },
      { feature: "웹 언어", value: "한국어, English, 러시아어,일본어" },
      { feature: "일반 동작온도/습도", value: "-20°C ~ 50°C / 90% RH 이하" },
      { feature: "일반 방진/방수", value: "IP66" },
      { feature: "일반 조절", value: "Y" },
      { feature: "일반 사용전원/소비전류", value: "DC12V, PoE(IEEE802.3af) / 1A(Max)" },
      { feature: "일반 재질/색상", value: "Aluminum / white / black" },
      { feature: "일반 중량", value: "1.5 Kg" },
      { feature: "일반 외 형 치 수", value: "108(W) X 370.1(L) X106.3(H)" },
      ],
    relatedProducts: [
      { id: "tnc-bz236v12af", badges: ["Network","IR","2M"] },
      { id: "tnc-b210v12afs", badges: ["Network","IR","2M"] },
      { id: "tnc-b510v12af", badges: ["Network","IR","5M"] },
      { id: "tnc-b120v12afs", badges: ["Network","IR","12M"] },
      { id: "utc-8060r", badges: ["UTC","IR","4K 8M"] },
      { id: "tnc-bf228afs", badges: ["Network","IR","2M","Fire Alarm"] },
      { id: "tnc-bf528af", badges: ["Network","IR","5M","Fire Alarm"] },
    ],
  },
  // TNC-BZ236V12AF
  {
    id: "tnc-bz236v12af",
    model: "TNC-BZ236V12AF",
    category: "bullet",
    categoryLabel: "Bullet",
    description: "2M Network IR Zoom Camera",
    aiSummary: "200만 화소 네트워크 적외선(IR) 불릿 카메라로, 36배율 고성능 줌 렌즈를 장착한 초장거리 감시 전용 모델입니다. 적외선 야간 가시거리 최대 120m를 지원하며, 넓은 지역의 원거리 세부 식별이 필요한 국경, 해안, 대형 인프라 시설 감시에 적합합니다.",
    allProductsImageKey: "Bullet/TNC-BZ236V12AF",
    images: [
      { key: "Bullet/TNC-BZ236V12AF", isDefault: true },
      { key: "Bullet/TNC-B210V12AFS", isDefault: false },
      { key: "Bullet/TNC-B217-V42AF", isDefault: false },
      { key: "Bullet/TNC-BZ204V12AFS", isDefault: false },
    ],
    badges: [
      { text: "Network", colorScheme: "green" },
      { text: "IR", colorScheme: "red" },
      { text: "2M", colorScheme: "blue" },
    ],
    keyFeatures: [
      "200만 화소 네트워크 카메라(1920x1080P @ 60fps)",
      "H.265 / H.264 / MJPEG  Triple 스트리밍 지원",
      "1/2” SONY CMOS 이미지 센서_IMX385",
      "Built In X36  AF 전용 ZOOM  LENS",
      "WDR(Wide Dynamic Range)",
      "DNR(Digital Noise Reduction)",
      "움직임 감지 기능",
      "양 뱡향 오디오 지원 ,ALARM IN &OUT",
      "FAN 내장 (내부 온도설정에 따른 자동 동작)",
      "IP66",
    ],
    specs: [
      { feature: "유효화소", value: "1920(H) x 1080(V)(Full-HD)" },
      { feature: "촬상소자", value: "1/2\" 2.1M Pixels Progressive Exmor Sensor" },
      { feature: "최소거리", value: "100mm~1200mm" },
      { feature: "S/N비", value: "54dB" },
      { feature: "최저조도", value: "0 Lux (IR LED ON)" },
      { feature: "초점 거리", value: "f=6.0mm ~ 216.0mm AF" },
      { feature: "초점 제어", value: "자동/수동 (네트워크를 통한 원격제어)" },
      { feature: "자동초점 (AuTo Exposure)", value: "YES" },
      { feature: "디지털 줌", value: "8x" },
      { feature: "OSD", value: "Off/ON" },
      { feature: "Flip/Mirror", value: "Off/On" },
      { feature: "노출(AE)", value: "자동/수동" },
      { feature: "셔터속도", value: "1/10000 ~ 1/30 (sec)" },
      { feature: "자동 조리개", value: "Off/On" },
      { feature: "AuTo Flicker-less", value: "Off/On" },
      { feature: "색 온도(AWB)", value: "자동(실내,실외), 그늘, 쾌청한 하늘, 형광등, 백열등, 불꽃, 수동" },
      { feature: "Day & NighT", value: "자동/주간/야간/외부신호" },
      { feature: "WDR,BLC,HLC,DNR", value: "Off/On" },
      { feature: "안개보정(Defog)", value: "Off/On/AuTo" },
      { feature: "세로모드", value: "Off/On (90도, 270도)" },
      { feature: "LDC 경계선", value: "Off/On" },
      { feature: "사생활 보호(Privacy Mask)", value: "8개 영역 지정가능" },
      { feature: "움직임 감지(MoTion DeTecTion)", value: "4개 Mask, 4개 DeTecTion 지정가능" },
      { feature: "이벤트 감지", value: "알람 입력,부팅감지,수동 트리거,네트워크감지" },
      { feature: "이벤트 동작", value: "알람 출력" },
      { feature: "화면 가림 감지(Temper)", value: "Off/On" },
      { feature: "야간가시거리", value: "70~120m(ISUPER R LED : 12개)" },
      { feature: "비디오 압축방식", value: "H.264/H265(High, Main ,Baseline Profile), MJPEG" },
      { feature: "비디오 해상도", value: "1920x1080, 1280x1024, 1280x720, 704x576, 704x480, 640x480, 640x360, 320x240" },
      { feature: "최대 프레임 레이트", value: "최대 60fps@ 1920x1080" },
      { feature: "오디오 압축방식", value: "G.711 ADPCM a-Law/u-Law" },
      { feature: "통신 양방향 입력(opTion)", value: "1Line-In" },
      { feature: "통신 양방향 출력(opTion)", value: "1Line-OuT" },
      { feature: "네트 워크 이더넷", value: "RJ-45(10/100BASE-T)" },
      { feature: "네트 워크 비트 레이트", value: "100 ~ 12000Kbps" },
      { feature: "네트 워크 IP", value: "IPv4, IPv6" },
      { feature: "네트 워크 ProTocol", value: "TCP/IP,UDP/IP,RTP,RTSP,HTTP,HTTPS,SMTP,FTP,DHCP,UPnP ,Zeroconf, DNS,DDNS" },
      { feature: "보안", value: "HTTPS암호화,사용자 관리, IP주소 필터링" },
      { feature: "FTP Uploading", value: "MJPEG STil Image" },
      { feature: "최대 동시 접속자", value: "10" },
      { feature: "S/W 응용 인터페이스", value: "Onvif profile S, ..." },
      { feature: "웹 뷰어 지원OS", value: "Windows VisTa(32biT)/7/8" },
      { feature: "웹 뷰어 지원 웹브라우져", value: "Micro Internet Explorer Ver.9, 10 Apple Safari Ver.4.0(Plug-in free viewer only) Google Chrome Ver.4.0(Plug-in free viewer only)" },
      { feature: "웹 언어", value: "한국어, English, 러시아어,일본어" },
      { feature: "일반 동작온도/습도", value: "-20°C ~ 50°C / 90% RH 이하" },
      { feature: "일반 방진/방수", value: "IP66" },
      { feature: "일반 조절", value: "Y" },
      { feature: "일반 사용전원/소비전류", value: "DC12V, PoE(IEEE802.3af) / 1A(Max)" },
      { feature: "일반 재질/색상", value: "Aluminum / whiTe/black" },
      { feature: "일반 중량", value: "1.5 Kg" },
      { feature: "일반 외 형 치 수", value: "108(W) X 370.1(L) X106.3(H)" },
      ],
    relatedProducts: [
      { id: "tnc-bz204v12afs", badges: ["Network","IR","2M"] },
      { id: "tnc-b210v12afs", badges: ["Network","IR","2M"] },
      { id: "tnc-b510v12af", badges: ["Network","IR","5M"] },
      { id: "tnc-b120v12afs", badges: ["Network","IR","12M"] },
      { id: "utc-8060r", badges: ["UTC","IR","4K 8M"] },
      { id: "tnc-bf228afs", badges: ["Network","IR","2M","Fire Alarm"] },
      { id: "tnc-bf528af", badges: ["Network","IR","5M","Fire Alarm"] },
    ],
  },
  // UTC-8060R
  {
    id: "utc-8060r",
    model: "UTC-8060R",
    category: "bullet",
    categoryLabel: "Bullet",
    description: "4K 8M IR Camera",
    aiSummary: "4K 800만 화소 고해상도 HD 적외선(IR) 불릿 카메라로, AHD/TVI/CVI/CVBS 다중 출력을 지원하는 아날로그 전용 모델입니다. 기존 아날로그 녹화기(DVR) 환경에서 고해상도 업그레이드가 필요한 곳에 적합합니다.",
    allProductsImageKey: "Bullet/TNC-B217-V42AF",
    images: [
      { key: "Bullet/TNC-BZ236V12AF", isDefault: false },
      { key: "Bullet/TNC-B210V12AFS", isDefault: false },
      { key: "Bullet/TNC-B217-V42AF", isDefault: true },
      { key: "Bullet/TNC-BZ204V12AFS", isDefault: false },
    ],
    badges: [
      { text: "IR", colorScheme: "red" },
      { text: "4K 8M", colorScheme: "blue" },
      { text: "UTC", colorScheme: "yellow" },
    ],
    keyFeatures: [
      "4K 고해상도  HD IR 카메라 (3840x2160 15fps)",
      "1/2.5 “8M Pixels Progressive Exmor Sensor",
      "F=3.6mm",
      "Multi  해상도 지원 (2M/4M/5M/8M)",
      "AHD (TVI/CVI/CVBS)",
      "D-WDR 지원",
      "Privacy Mask 8 Area 기능",
      "2D, 3D 잡음제거 설정 가능",
      "SMART IR 설정 지원",
      "UTC(UP TO COAX)",
      "OSD 제어 케이블 (옵션)",
      "PIR 기능지원 (IRLED & WHITE LED) (옵션)",
      "IP66",
    ],
    specs: [
      { feature: "MODEL", value: "" },
      { feature: "유효화소", value: "3840(H) x 2160(V)" },
      { feature: "촬상소자", value: "1/2.5\" 8M Pixels Progressive Exmor Sensor" },
      { feature: "최소거리", value: "100mm~1200mm" },
      { feature: "S/N비", value: "54dB" },
      { feature: "최저조도", value: "주간: 0.01Lux, 야간: 0 Lux (IR LED ON)" },
      { feature: "초점 거리", value: "F-3.6mm" },
      { feature: "초점 제어", value: "고정" },
      { feature: "해상도", value: "2592X1944(20fps), 2688x1520(30fps), 1920x1080(30fps)" },
      { feature: "LSC(Lens Shading Correction)", value: "고정" },
      { feature: "OSD", value: "지원" },
      { feature: "Flip/Mirror", value: "Adjust" },
      { feature: "노출(AE)", value: "Adjust" },
      { feature: "셔터속도", value: "1/10000 ~ 1/30 (sec)" },
      { feature: "자동 조리개", value: "고정" },
      { feature: "Auto Flicker-less", value: "Adjust" },
      { feature: "색 온도(AWB)", value: "자동(실내,실외), 그늘, 쾌청한 하늘, 형광등, 백열등, 불꽃, 수동" },
      { feature: "Day & Night", value: "자동/주간/야간/외부신호 _고정" },
      { feature: "AE,BLC,HLC,DNR", value: "Adjust" },
      { feature: "안개보정(Defog)", value: "Adjust" },
      { feature: "사생활 보호(Privacy Mask)", value: "Adjust" },
      { feature: "움직임 감지(Motion Detection)", value: "Adjust" },
      { feature: "적외선 LED", value: "SUPER IR 6EA" },
      { feature: "영상출력", value: "AHD (TVI/CVI/CVBS)" },
      { feature: "전원 입력", value: "DC JACK" },
      { feature: "영상출력", value: "BNC / CVBS (옵션)" },
      { feature: "EXT OSD", value: "OSD KEY (옵션)" },
      { feature: "동작온도/습도", value: "-20°C ~ 50°C / 90% RH 이하" },
      { feature: "조절", value: "3축 조절기능" },
      { feature: "사용전원/소비전류", value: "DC12V / 510mA(Max)" },
      { feature: "중량", value: "1Kg" },
      { feature: "외 형 치 수", value: "84mm(W) X84mm(H)X282 mm(L)" },
      { feature: "방진/방수", value: "Y" },
      { feature: "충격대응", value: "Y" },
      ],
    relatedProducts: [
      { id: "tnc-bz236v12af", badges: ["Network","IR","2M"] },
      { id: "tnc-bz204v12afs", badges: ["Network","IR","2M"] },
      { id: "tnc-b210v12afs", badges: ["Network","IR","2M"] },
      { id: "tnc-b510v12af", badges: ["Network","IR","5M"] },
      { id: "tnc-b120v12afs", badges: ["Network","IR","12M"] },
      { id: "tnc-bf228afs", badges: ["Network","IR","2M","Fire Alarm"] },
      { id: "tnc-bf528af", badges: ["Network","IR","5M","Fire Alarm"] },
    ],
  },
  // TNC-D210V21AF
  {
    id: "tnc-d210v21af",
    model: "TNC-D210V21AF",
    category: "dome",
    categoryLabel: "Dome",
    description: "2M IR Camera",
    aiSummary: "200만 화소 풀HD 네트워크 적외선(IR) 돔 카메라로, 실내 설치에 최적화된 컴팩트한 디자인입니다. 자동초점 줌 렌즈와 적외선 LED로 밤낮으로 선명한 영상을 제공하며, WDR과 안개보정 기능으로 역광이나 안개 환경에서도 안정적인 감시가 가능합니다.",
    allProductsImageKey: "Dome/TNC-D210V21AF",
    images: [
      { key: "Dome/TNC-D210V21AF", isDefault: true },
      { key: "Dome/TNC-FV120F", isDefault: false },
      { key: "Dome/TNC-V210F18", isDefault: false },
      { key: "Dome/TNC-D210V30AFS", isDefault: false },
    ],
    badges: [
      { text: "Network", colorScheme: "green" },
      { text: "IR", colorScheme: "red" },
      { text: "2M", colorScheme: "blue" },
    ],
    keyFeatures: [
      "200만 화소 네트워크 카메라(1920x1080P @ 30fps)",
      "H.265 / H.264 / MJPEG  Triple 스트리밍 지원",
      "1/ 2.8” SONY CMOS 이미지 센서",
      "Built In AF ZOOM LENS",
      "WDR(Wide Dynamic Range)",
      "DNR(Digital Noise Reduction)",
      "2.8~12mmAF / / Lens 2.8mm ,3.6mm,6mm (옵션)",
      "움직임 감지 기능",
    ],
    specs: [
      { feature: "유효화소", value: "1920(H) x 1080(V)(Full-HD)" },
      { feature: "촬상소자", value: "1/ 2.8\" 2.1M Pixels Progressive Exmor Sensor" },
      { feature: "최소거리", value: "100mm~1200mm" },
      { feature: "S/N비", value: "54dB" },
      { feature: "최저조도", value: "0 Lux (IR LED ON)" },
      { feature: "초점 거리", value: "F=2.8~12mmAF" },
      { feature: "초점 제어", value: "자동/수동 (네트워크를 통한 원격제어)" },
      { feature: "자동초점 (Auto Exposure)", value: "YES" },
      { feature: "디지털 줌", value: "8x" },
      { feature: "OSD", value: "Off/ON" },
      { feature: "Flip/Mirror", value: "Off/On" },
      { feature: "노출(AE)", value: "자동/수동" },
      { feature: "셔터속도", value: "1/10000 ~ 1/30 (sec)" },
      { feature: "자동 조리개", value: "Off/On" },
      { feature: "Auto Flicker-less", value: "Off/On" },
      { feature: "색 온도(AWB)", value: "자동(실내,실외), 그늘, 쾌청한 하늘, 형광등, 백열등, 불꽃, 수동" },
      { feature: "Day & Night", value: "자동/주간/야간/외부신호" },
      { feature: "WDR,BLC,HLC,DNR", value: "Off/On" },
      { feature: "안개보정(Defog)", value: "Off/On/Auto" },
      { feature: "세로모드", value: "Off/On (90도, 270도)" },
      { feature: "LDC 경계선", value: "Off/On" },
      { feature: "사생활 보호(Privacy Mask)", value: "8개 영역 지정가능" },
      { feature: "움직임 감지(Motion Detection)", value: "4개 Mask, 4개 Detection 지정가능" },
      { feature: "이벤트 감지", value: "알람 입력,부팅감지,수동 트리거,네트워크감지" },
      { feature: "이벤트 동작", value: "알람 출력" },
      { feature: "화면 가림 감지(Temper)", value: "Off/On" },
      { feature: "야간가시거리", value: "IR LED : 21개" },
      { feature: "압축방식", value: "H.264/H265(High, Main ,Baseline Profile), MJPEG" },
      { feature: "해상도", value: "1920x1080, 1280x1024, 1280x720, 704x576, 704x480, 640x480, 640x360, 320x240" },
      { feature: "최대 프레임 레이트", value: "최대 30fps@ 1920x1080" },
      { feature: "압축방식", value: "G.711 ADPCM a-Law/u-Law" },
      { feature: "통신", value: "양방향" },
      { feature: "입력(option)", value: "1Line-In" },
      { feature: "출력(option)", value: "1Line-Out" },
      { feature: "이더넷", value: "RJ-45(10/100BASE-T)" },
      { feature: "비트 레이트", value: "100 ~ 12000Kbps" },
      { feature: "IP", value: "IPv4, IPv6" },
      { feature: "Protocol", value: "TCP/IP,UDP/IP,RTP,RTSP,HTTP,HTTPS,SMTP,FTP,DHCP,UPnP ,Zeroconf, DNS,DDNS" },
      { feature: "보안", value: "HTTPS암호화,사용자 관리, IP주소 필터링" },
      { feature: "FTP Uploading", value: "MJPEG Stil Image" },
      { feature: "최대 동시 접속자", value: "10" },
      { feature: "S/W 응용 인터페이스", value: "Onvif profile S, ..." },
      { feature: "지원OS", value: "Windows Vista(32bit)/7/8" },
      { feature: "지원 웹브라우져", value: "MicroSoft Internet Explorer Ver.9, 10, Apple Safari Ver.4.0(Plug-in free viewer only), Google Chrome Ver.4.0(Plug-in free viewer only)" },
      { feature: "웹 언어", value: "한국어, English, 러시아어,일본어" },
      { feature: "동작온도/습도", value: "-20°C ~ 50°C / 90% RH 이하" },
      { feature: "방진/방수", value: "X" },
      { feature: "조절", value: "조절기능 ." },
      { feature: "사용전원/소비전류", value: "DC12V, PoE(IEEE802.3af) / 1A(Max)" },
      { feature: "재질/색상", value: "Plastic / White / Black" },
      { feature: "중량", value: "430g" },
      { feature: "외 형 치 수", value: "127mm(W) X92 mm(H)" },
      ],
    relatedProducts: [
      { id: "tnc-fv120f", badges: ["Network","Fisheye","12M"] },
      { id: "tnc-v210f18", badges: ["Network","IR","2M"] },
      { id: "tnc-d210v21afs", badges: ["Network","IR","2M"] },
      { id: "tnc-d210v30afs", badges: ["Network","IR","2M"] },
      { id: "tnc-d510v21af", badges: ["Network","IR","5M"] },
      { id: "utc-800dr", badges: ["UTC","IR","4K 8M"] },
    ],
  },
  // TNC-D210V21AFS
  {
    id: "tnc-d210v21afs",
    model: "TNC-D210V21AFS",
    category: "dome",
    categoryLabel: "Dome",
    description: "2M IR Camera",
    aiSummary: "200만 화소 풀HD 네트워크 적외선(IR) 돔 카메라로, SONY IMX385 고성능 센서를 탑재해 우수한 화질을 제공합니다. 최대 60fps 지원과 자동초점 줌 렌즈를 갖추고 있으며, 실내 환경에서 부드럽고 선명한 감시 영상이 필요한 매장, 학교, 사무실 등에 적합합니다.",
    allProductsImageKey: "Dome/TNC-D210V21AF",
    images: [
      { key: "Dome/TNC-D210V21AF", isDefault: true },
      { key: "Dome/TNC-FV120F", isDefault: false },
      { key: "Dome/TNC-V210F18", isDefault: false },
      { key: "Dome/TNC-D210V30AFS", isDefault: false },
    ],
    badges: [
      { text: "Network", colorScheme: "green" },
      { text: "IR", colorScheme: "red" },
      { text: "2M", colorScheme: "blue" },
    ],
    keyFeatures: [
      "200만 화소 네트워크 카메라(1920x1080P @ 60fps)",
      "H.265 / H.264 / MJPEG Triple 스트리밍 지원",
      "1/ 2” SONY CMOS 이미지 센서_IMX385",
      "Built In AF ZOOM LENS",
      "WDR(Wide Dynamic Range)",
      "DNR(Digital Noise Reduction)",
      "3.6~12mmAF / Lens 2.8mm ,3.6mm,6mm (옵션)",
      "움직임 감지 기능",
    ],
    specs: [
      { feature: "유효화소", value: "1920(H) x 1080(V)(Full-HD)" },
      { feature: "촬상소자", value: "1/ 2\" 2.1M Pixels Progressive Exmor Sensor" },
      { feature: "최소거리", value: "100mm~1200mm" },
      { feature: "S/N비", value: "54dB" },
      { feature: "최저조도", value: "0 Lux (IR LED ON)" },
      { feature: "초점 거리", value: "F=2.8~12mmAF" },
      { feature: "초점 제어", value: "자동/수동 (네트워크를 통한 원격제어)" },
      { feature: "자동초점 (Auto Exposure)", value: "YES" },
      { feature: "디지털 줌", value: "8x" },
      { feature: "OSD", value: "Off/ON" },
      { feature: "Flip/Mirror", value: "Off/On" },
      { feature: "노출(AE)", value: "자동/수동" },
      { feature: "셔터속도", value: "1/10000 ~ 1/30 (sec)" },
      { feature: "자동 조리개", value: "Off/On" },
      { feature: "Auto Flicker-less", value: "Off/On" },
      { feature: "색 온도(AWB)", value: "자동(실내,실외), 그늘, 쾌청한 하늘, 형광등, 백열등, 불꽃, 수동" },
      { feature: "Day & Night", value: "자동/주간/야간/외부신호" },
      { feature: "WDR,BLC,HLC,DNR", value: "Off/On" },
      { feature: "안개보정(Defog)", value: "Off/On/Auto" },
      { feature: "세로모드", value: "Off/On (90도, 270도)" },
      { feature: "LDC 경계선", value: "Off/On" },
      { feature: "사생활 보호(Privacy Mask)", value: "8개 영역 지정가능" },
      { feature: "움직임 감지(Motion Detection)", value: "4개 Mask, 4개 Detection 지정가능" },
      { feature: "이벤트 감지", value: "알람 입력,부팅감지,수동 트리거,네트워크감지" },
      { feature: "이벤트 동작", value: "알람 출력" },
      { feature: "화면 가림 감지(Temper)", value: "Off/On" },
      { feature: "야간가시거리", value: "IR LED : 21개" },
      { feature: "압축방식", value: "H.264/H265(High, Main ,Baseline Profile), MJPEG" },
      { feature: "해상도", value: "1920x1080, 1280x1024, 1280x720, 704x576, 704x480, 640x480, 640x360, 320x240" },
      { feature: "최대 프레임 레이트", value: "최대 30fps@ 1920x1080" },
      { feature: "압축방식", value: "G.711 ADPCM a-Law/u-Law" },
      { feature: "통신", value: "양방향" },
      { feature: "입력(option)", value: "1Line-In" },
      { feature: "출력(option)", value: "1Line-Out" },
      { feature: "이더넷", value: "RJ-45(10/100BASE-T)" },
      { feature: "비트 레이트", value: "100 ~ 12000Kbps" },
      { feature: "IP", value: "IPv4, IPv6" },
      { feature: "Protocol", value: "TCP/IP,UDP/IP,RTP,RTSP,HTTP,HTTPS,SMTP,FTP,DHCP,UPnP ,Zeroconf, DNS,DDNS" },
      { feature: "보안", value: "HTTPS암호화,사용자 관리, IP주소 필터링" },
      { feature: "FTP Uploading", value: "MJPEG Stil Image" },
      { feature: "최대 동시 접속자", value: "10" },
      { feature: "S/W 응용 인터페이스", value: "Onvif profile S, ..." },
      { feature: "지원OS", value: "Windows Vista(32bit)/7/8" },
      { feature: "지원 웹브라우져", value: "MicroSoft Internet Explorer Ver.9, 10, Apple Safari Ver.4.0(Plug-in free viewer only), Google Chrome Ver.4.0(Plug-in free viewer only)" },
      { feature: "웹 언어", value: "한국어, English, 러시아어,일본어" },
      { feature: "동작온도/습도", value: "-20°C ~ 50°C / 90% RH 이하" },
      { feature: "방진/방수", value: "X" },
      { feature: "조절", value: "조절기능 ." },
      { feature: "사용전원/소비전류", value: "DC12V, PoE(IEEE802.3af) / 1.0A(Max)" },
      { feature: "재질/색상", value: "Plastic / White / Black" },
      { feature: "중량", value: "430g" },
      { feature: "외 형 치 수", value: "127mm(W) X92 mm(H)" },
      ],
    relatedProducts: [
      { id: "tnc-fv120f", badges: ["Network","Fisheye","12M"] },
      { id: "tnc-v210f18", badges: ["Network","IR","2M"] },
      { id: "tnc-d210v21af", badges: ["Network","IR","2M"] },
      { id: "tnc-d210v30afs", badges: ["Network","IR","2M"] },
      { id: "tnc-d510v21af", badges: ["Network","IR","5M"] },
      { id: "utc-800dr", badges: ["UTC","IR","4K 8M"] },
    ],
  },
  // TNC-D210V30AFS
  {
    id: "tnc-d210v30afs",
    model: "TNC-D210V30AFS",
    category: "dome",
    categoryLabel: "Dome",
    description: "2M IR Camera",
    aiSummary: "200만 화소 풀HD 네트워크 적외선(IR) 돔 카메라로, 30개의 적외선 LED를 장착해 넓은 야간 가시거리를 제공합니다. SONY IMX385 센서 기반의 최대 60fps 영상과 WDR, DNR 등 화질 보정 기능을 지원하여, 안정적인 야간 감시가 필요한 곳에 적합합니다.",
    allProductsImageKey: "Dome/TNC-D210V30AFS",
    images: [
      { key: "Dome/TNC-D210V21AF", isDefault: false },
      { key: "Dome/TNC-FV120F", isDefault: false },
      { key: "Dome/TNC-V210F18", isDefault: false },
      { key: "Dome/TNC-D210V30AFS", isDefault: true },
    ],
    badges: [
      { text: "Network", colorScheme: "green" },
      { text: "IR", colorScheme: "red" },
      { text: "2M", colorScheme: "blue" },
    ],
    keyFeatures: [
      "200만 화소 네트워크 카메라(1920x1080P @ 60fps)",
      "H.265 / H.264 / MJPEG Triple 스트리밍 지원",
      "1/ 2” SONY CMOS 이미지 센서_IMX385",
      "Built In AF ZOOM LENS",
      "WDR(Wide Dynamic Range)",
      "DNR(Digital Noise Reduction)",
      "3.6~12mmAF / Lens 2.8mm ,3.6mm,6mm (옵션)",
      "움직임 감지 기능",
    ],
    specs: [
      { feature: "유효화소", value: "1920(H) x 1080(V)(Full-HD)" },
      { feature: "촬상소자", value: "1/ 2\" 2.1M Pixels Progressive Exmor Sensor" },
      { feature: "최소거리", value: "100mm~1200mm" },
      { feature: "S/N비", value: "54dB" },
      { feature: "최저조도", value: "0 Lux (IR LED ON)" },
      { feature: "초점 거리", value: "F=2.8~12mmAF" },
      { feature: "초점 제어", value: "자동/수동 (네트워크를 통한 원격제어)" },
      { feature: "자동초점 (Auto Exposure)", value: "YES" },
      { feature: "디지털 줌", value: "8x" },
      { feature: "OSD", value: "Off/ON" },
      { feature: "Flip/Mirror", value: "Off/On" },
      { feature: "노출(AE)", value: "자동/수동" },
      { feature: "셔터속도", value: "1/10000 ~ 1/30 (sec)" },
      { feature: "자동 조리개", value: "Off/On" },
      { feature: "Auto Flicker-less", value: "Off/On" },
      { feature: "색 온도(AWB)", value: "자동(실내,실외), 그늘, 쾌청한 하늘, 형광등, 백열등, 불꽃, 수동" },
      { feature: "Day & Night", value: "자동/주간/야간/외부신호" },
      { feature: "WDR,BLC,HLC,DNR", value: "Off/On" },
      { feature: "안개보정(Defog)", value: "Off/On/Auto" },
      { feature: "세로모드", value: "Off/On (90도, 270도)" },
      { feature: "LDC 경계선", value: "Off/On" },
      { feature: "사생활 보호(Privacy Mask)", value: "8개 영역 지정가능" },
      { feature: "움직임 감지(Motion Detection)", value: "4개 Mask, 4개 Detection 지정가능" },
      { feature: "이벤트 감지", value: "알람 입력,부팅감지,수동 트리거,네트워크감지" },
      { feature: "이벤트 동작", value: "알람 출력" },
      { feature: "화면 가림 감지(Temper)", value: "Off/On" },
      { feature: "야간가시거리", value: "IR LED : 30개" },
      { feature: "압축방식", value: "H.264/H265(High, Main ,Baseline Profile), MJPEG" },
      { feature: "해상도", value: "1920x1080, 1280x1024, 1280x720, 704x576, 704x480, 640x480, 640x360, 320x240" },
      { feature: "최대 프레임 레이트", value: "최대 30fps@ 1920x1080" },
      { feature: "압축방식", value: "G.711 ADPCM a-Law/u-Law" },
      { feature: "통신", value: "양방향" },
      { feature: "입력(option)", value: "1Line-In" },
      { feature: "출력(option)", value: "1Line-Out" },
      { feature: "이더넷", value: "RJ-45(10/100BASE-T)" },
      { feature: "비트 레이트", value: "100 ~ 12000Kbps" },
      { feature: "IP", value: "IPv4, IPv6" },
      { feature: "Protocol", value: "TCP/IP,UDP/IP,RTP,RTSP,HTTP,HTTPS,SMTP,FTP,DHCP,UPnP ,Zeroconf, DNS,DDNS" },
      { feature: "보안", value: "HTTPS암호화,사용자 관리, IP주소 필터링" },
      { feature: "FTP Uploading", value: "MJPEG Stil Image" },
      { feature: "최대 동시 접속자", value: "10" },
      { feature: "S/W 응용 인터페이스", value: "Onvif profile S, ..." },
      { feature: "지원OS", value: "Windows Vista(32bit)/7/8" },
      { feature: "지원 웹브라우져", value: "MicroSoft Internet Explorer Ver.9, 10, Apple Safari Ver.4.0(Plug-in free viewer only), Google Chrome Ver.4.0(Plug-in free viewer only)" },
      { feature: "웹 언어", value: "한국어, English, 러시아어,일본어" },
      { feature: "동작온도/습도", value: "-20°C ~ 50°C / 90% RH 이하" },
      { feature: "방진/방수", value: "X" },
      { feature: "조절", value: "조절기능 ." },
      { feature: "사용전원/소비전류", value: "DC12V, PoE(IEEE802.3af) / 1.0A(Max)" },
      { feature: "재질/색상", value: "Plastic / White / Black" },
      { feature: "중량", value: "430g" },
      { feature: "외 형 치 수", value: "127mm(W) X92 mm(H)" },
      ],
    relatedProducts: [
      { id: "tnc-fv120f", badges: ["Network","Fisheye","12M"] },
      { id: "tnc-v210f18", badges: ["Network","IR","2M"] },
      { id: "tnc-d210v21af", badges: ["Network","IR","2M"] },
      { id: "tnc-d510v21af", badges: ["Network","IR","5M"] },
      { id: "utc-800dr", badges: ["UTC","IR","4K 8M"] },
    ],
  },
  // TNC-D510V21AF
  {
    id: "tnc-d510v21af",
    isNew: true,
    model: "TNC-D510V21AF",
    category: "dome",
    categoryLabel: "Dome",
    description: "5M IR Camera",
    aiSummary: "500만 화소 네트워크 적외선(IR) 돔 카메라로, SONY IMX335 센서와 자동초점 줌 렌즈를 탑재했습니다. 고해상도 영상과 적외선 LED로 넓은 야간 가시거리를 제공하며, 식별 정확도가 높아야 하는 실내외 감시 구역에 적합합니다.",
    allProductsImageKey: "Dome/TNC-D210V21AF",
    images: [
      { key: "Dome/TNC-D210V21AF", isDefault: true },
      { key: "Dome/TNC-FV120F", isDefault: false },
      { key: "Dome/TNC-V210F18", isDefault: false },
      { key: "Dome/TNC-D210V30AFS", isDefault: false },
    ],
    badges: [
      { text: "Network", colorScheme: "green" },
      { text: "IR", colorScheme: "red" },
      { text: "5M", colorScheme: "blue" },
    ],
    keyFeatures: [
      "500만 화소 네트워크 카메라(2592x1944P @ 30fps)",
      "H.265 / H.264 / MJPEG  Triple 스트리밍 지원",
      "1/2.8” SONY CMOS 이미지 센서 IMX335",
      "Built In AF ZOOM LENS",
      "WDR(Wide Dynamic Range)",
      "DNR(Digital Noise Reduction)",
      "2.7~13.5mmAF /,2.8mm ,3.6mm,6mm (옵션)",
      "움직임 감지 기능",
    ],
    specs: [
      { feature: "유효화소", value: "1920(H) x 1080(V)( Full-HD)" },
      { feature: "촬상소자", value: "1/2.8 \" 5.6M Pixels Progressive Exmor Sensor" },
      { feature: "최소거리", value: "100mm~1200mm" },
      { feature: "S/N비", value: "54dB" },
      { feature: "최저조도", value: "0 Lux (IR LED ON)" },
      { feature: "초점 거리", value: "2.7~13.5mmAF/2.8mm ,3.6mm,6m (Option)" },
      { feature: "초점 제어", value: "자동/수동 (네트워크를 통한 원격제어)" },
      { feature: "자동초점 (Auto Exposure)", value: "YES" },
      { feature: "디지털 줌", value: "8x" },
      { feature: "OSD", value: "Off/ON" },
      { feature: "Flip/Mirror", value: "Off/On" },
      { feature: "노출(AE)", value: "자동/수동" },
      { feature: "셔터속도", value: "1/10000 ~ 1/30 (sec)" },
      { feature: "자동 조리개", value: "Off/On" },
      { feature: "Auto Flicker-less", value: "Off/On" },
      { feature: "색 온도(AWB)", value: "자동(실내,실외), 그늘, 쾌청한 하늘, 형광등, 백열등, 불꽃, 수동" },
      { feature: "Day & Night", value: "자동/주간/야간/외부신호" },
      { feature: "WDR,BLC,HLC,DNR", value: "Off/On" },
      { feature: "안개보정(Defog)", value: "Off/On/Auto" },
      { feature: "세로모드", value: "Off/On (90도, 270도)" },
      { feature: "LDC 경계선", value: "Off/On" },
      { feature: "사생활 보호(Privacy Mask)", value: "8개 영역 지정가능" },
      { feature: "움직임 감지(Motion Detection)", value: "4개 Mask, 4개 Detection 지정가능" },
      { feature: "이벤트 감지", value: "알람 입력,부팅감지,수동 트리거,네트워크감지" },
      { feature: "이벤트 동작", value: "알람 출력" },
      { feature: "화면 가림 감지(Temper)", value: "Off/On" },
      { feature: "야간가시거리", value: "IR LED : 30개" },
      { feature: "압축방식", value: "H.264/H265(High, Main ,Baseline Profile), MJPEG" },
      { feature: "해상도", value: "2592X1944,1920x1080, 1280x1024, 1280x720, 704x576,704x480, 640x480, 640x360, 320x240" },
      { feature: "최대 프레임 레이트", value: "최대 30fps@ 1920x1080" },
      { feature: "압축방식", value: "G.711 ADPCM a-Law/u-Law" },
      { feature: "통신", value: "양방향" },
      { feature: "입력(option)", value: "1Line-In" },
      { feature: "출력(option)", value: "1Line-Out" },
      { feature: "이더넷", value: "RJ-45(10/100BASE-T)" },
      { feature: "비트 레이트", value: "100 ~ 12000Kbps" },
      { feature: "IP", value: "IPv4, IPv6" },
      { feature: "Protocol", value: "TCP/IP,UDP/IP,RTP,RTSP,HTTP,HTTPS,SMTP,FTP,DHCP,UPnP ,Zeroconf, DNS,DDNS" },
      { feature: "보안", value: "HTTPS암호화,사용자 관리, IP주소 필터링" },
      { feature: "FTP Uploading", value: "MJPEG Stil Image" },
      { feature: "최대 동시 접속자", value: "10" },
      { feature: "S/W 응용 인터페이스", value: "Onvif profile S, ..." },
      { feature: "지원OS", value: "Windows Vista(32bit)/7/8" },
      { feature: "지원 웹브라우져", value: "MicroSoft Internet Explorer Ver.9, 10, Apple Safari Ver.4.0(Plug-in free viewer only), Google Chrome Ver.4.0(Plug-in free viewer only)" },
      { feature: "웹 언어", value: "한국어, English, 러시아어,일본어" },
      { feature: "동작온도/습도", value: "-20°C ~ 50°C / 90% RH 이하" },
      { feature: "방진/방수", value: "X" },
      { feature: "조절", value: "조절기능 ." },
      { feature: "사용전원/소비전류", value: "DC12V, PoE(IEEE802.3af) / 1A(Max)" },
      { feature: "재질/색상", value: "Plastic / White / Black" },
      { feature: "중량", value: "430g" },
      { feature: "외 형 치 수", value: "127mm(W) X92 mm(H)" },
      ],
    relatedProducts: [
      { id: "tnc-fv120f", badges: ["Network","Fisheye","12M"] },
      { id: "tnc-v210f18", badges: ["Network","IR","2M"] },
      { id: "tnc-d210v21af", badges: ["Network","IR","2M"] },
      { id: "tnc-d210v21afs", badges: ["Network","IR","2M"] },
      { id: "tnc-d210v30afs", badges: ["Network","IR","2M"] },
      { id: "utc-800dr", badges: ["UTC","IR","4K 8M"] },
    ],
  },
  // TNC-FV120F
  {
    id: "tnc-fv120f",
    isNew: true,
    model: "TNC-FV120F",
    category: "dome",
    categoryLabel: "Dome",
    description: "12M Fisheye Camera",
    aiSummary: "1200만 화소 네트워크 어안(Fisheye) 돔 카메라로, 360도 파노라마 뷰를 한 대로 감시할 수 있는 특수 카메라입니다. Fisheye Dewarping 기능으로 왜곡을 보정한 영상을 제공하며, 넓은 공간을 한 대로 전체 감시해야 하는 매장, 창고, 로비 등에 적합합니다.",
    allProductsImageKey: "Dome/TNC-FV120F",
    images: [
      { key: "Dome/TNC-D210V21AF", isDefault: false },
      { key: "Dome/TNC-FV120F", isDefault: true },
      { key: "Dome/TNC-V210F18", isDefault: false },
      { key: "Dome/TNC-D210V30AFS", isDefault: false },
    ],
    badges: [
      { text: "Network", colorScheme: "green" },
      { text: "Fisheye", colorScheme: "red" },
      { text: "12M", colorScheme: "blue" },
    ],
    keyFeatures: [
      "12M  화소 네트워크 PTZ 카메라(4000x3000p @15fps) / 3840x2160 @30fps  4K 지원",
      "H.265 / H.264 / MJPEG  Triple 스트리밍 지원",
      "1/ 2.3” SONY CMOS  이미지센서(IMX412)",
      "Fisheye Dewarping 기능 지원",
      "1.85mm , 360 어안 렌즈",
      "네트워크를 통한  360 파노라마 뷰  영상 제공",
      "IP66",
    ],
    specs: [
      { feature: "유효화소", value: "4000(H) x 3000 (V)( Full-HD)" },
      { feature: "촬상소자", value: "1/2.3\" 12M Pixels Progressive Exmor Sensor" },
      { feature: "최소거리", value: "100mm~1200mm" },
      { feature: "S/N비", value: "54dB" },
      { feature: "최저조도", value: "1.COLOR: 0.01 lux / DSS 0.001 lux ,2.BW:0.002 lux / DSS 0.0002 lux" },
      { feature: "초점 거리", value: "F=1.85 mm" },
      { feature: "초점 제어", value: "자동/수동 (네트워크를 통한 원격제어)" },
      { feature: "자동초점 (Auto Exposure)", value: "X" },
      { feature: "디지털 줌", value: "8x" },
      { feature: "OSD", value: "Off/ON" },
      { feature: "Flip/Mirror", value: "Off/On" },
      { feature: "노출(AE)", value: "자동/수동" },
      { feature: "셔터속도", value: "1/10000 ~ 1/30 (sec)" },
      { feature: "자동 조리개", value: "Off/On" },
      { feature: "Auto Flicker-less", value: "Off/On" },
      { feature: "색 온도(AWB)", value: "자동(실내,실외), 그늘, 쾌청한 하늘, 형광등, 백열등, 불꽃, 수동" },
      { feature: "Day & Night", value: "자동/주간/야간/외부신호" },
      { feature: "WDR,BLC,HLC,DNR", value: "Off/On" },
      { feature: "안개보정(Defog)", value: "Off/On/Auto" },
      { feature: "세로모드", value: "Off/On (90도, 270도)" },
      { feature: "LDC 경계선", value: "Off/On" },
      { feature: "사생활 보호(Privacy Mask)", value: "8개 영역 지정가능" },
      { feature: "움직임 감지(Motion Detection)", value: "4개 Mask, 4개 Detection 지정가능" },
      { feature: "이벤트 감지", value: "알람 입력,부팅감지,수동 트리거,네트워크감지" },
      { feature: "이벤트 동작", value: "알람 출력" },
      { feature: "화면 가림 감지(Temper)", value: "Off/On" },
      { feature: "야간가시거리", value: "-" },
      { feature: "압축방식", value: "H.264/H265(High, Main ,Baseline Profile), MJPEG" },
      { feature: "해상도", value: "4000X3000, 3840X2160, 2592X1944, 2048X1536, 1920x1080, 1280x1024, 1280x720, 704x576, 704x480, 640x480, 640x360, 320x240" },
      { feature: "최대 프레임 레이트", value: "최대 15fps@4000 x 3000" },
      { feature: "압축방식", value: "G.711 ADPCM a-Law/u-Law" },
      { feature: "통신", value: "양방향" },
      { feature: "입력(option)", value: "1Line-In" },
      { feature: "출력(option)", value: "1Line-Out" },
      { feature: "이더넷", value: "RJ-45(10/100BASE-T)" },
      { feature: "비트 레이트", value: "100 ~ 12000Kbps" },
      { feature: "IP", value: "IPv4, IPv6" },
      { feature: "Protocol", value: "TCP/IP,UDP/IP,RTP,RTSP,HTTP,HTTPS,SMTP,FTP,DHCP,UPnP ,Zeroconf, DNS,DDNS" },
      { feature: "보안", value: "HTTPS암호화,사용자 관리, IP주소 필터링" },
      { feature: "FTP Uploading", value: "MJPEG Stil Image" },
      { feature: "최대 동시 접속자", value: "10" },
      { feature: "S/W 응용 인터페이스", value: "Onvif profile S, ..." },
      { feature: "지원OS", value: "Windows Vista(32bit)/7/8" },
      { feature: "지원 웹브라우져", value: "MicroSoft Internet Explorer Ver.9, 10, Apple Safari Ver.4.0(Plug-in free viewer only), Google Chrome Ver.4.0(Plug-in free viewer only)" },
      { feature: "웹 언어", value: "한국어, English, 러시아어,일본어" },
      { feature: "동작온도/습도", value: "-20°C ~ 50°C / 90% RH 이하" },
      { feature: "방진/방수", value: "IP66" },
      { feature: "조절", value: "조절기능 ." },
      { feature: "사용전원/소비전류", value: "DC12V, PoE(IEEE802.3af) / 1A(Max)" },
      { feature: "재질/색상", value: "Aluminum / Ivory" },
      { feature: "중량", value: "480g" },
      { feature: "외 형 치 수", value: "104(Ø) x 91(H)mm" },
      ],
    relatedProducts: [
      { id: "tnc-v210f18", badges: ["Network","IR","2M"] },
      { id: "tnc-d210v21af", badges: ["Network","IR","2M"] },
      { id: "tnc-d210v21afs", badges: ["Network","IR","2M"] },
      { id: "tnc-d210v30afs", badges: ["Network","IR","2M"] },
      { id: "tnc-d510v21af", badges: ["Network","IR","5M"] },
      { id: "utc-800dr", badges: ["UTC","IR","4K 8M"] },
    ],
  },
  // TNC-V210F18
  {
    id: "tnc-v210f18",
    model: "TNC-V210F18",
    category: "dome",
    categoryLabel: "Dome",
    description: "2M IR Camera",
    aiSummary: "200만 화소 네트워크 적외선(IR) 돔 카메라로, 적외선 LED를 장착해 밤에도 선명한 영상을 제공합니다. 어안 렌즈와 일반 렌즈 옵션을 모두 지원하며, IP66 방진방수 등급으로 야외 설치도 가능합니다. 넓은 시야각 감시가 필요한 곳에 적합합니다.",
    allProductsImageKey: "Dome/TNC-V210F18",
    images: [
      { key: "Dome/TNC-D210V21AF", isDefault: false },
      { key: "Dome/TNC-FV120F", isDefault: false },
      { key: "Dome/TNC-V210F18", isDefault: true },
      { key: "Dome/TNC-D210V30AFS", isDefault: false },
    ],
    badges: [
      { text: "Network", colorScheme: "green" },
      { text: "IR", colorScheme: "red" },
      { text: "2M", colorScheme: "blue" },
    ],
    keyFeatures: [
      "200만 화소 네트워크 카메라(1920x1080P @ 30fps)",
      "H.265 / H.264 / MJPEG  Triple 스트리밍 지원",
      "1/ 2.8” SONY CMOS 이미지 센서",
      "Built In AF ZOOM LENS",
      "WDR(Wide Dynamic Range)",
      "DNR(Digital Noise Reduction)",
      "2.1mm, 2.8mm / 2.8~12mmAF (옵션)",
      "움직임 감지 기능",
      "IP66",
    ],
    specs: [
      { feature: "유효화소", value: "1920(H) x 1080(V)(Full-HD)" },
      { feature: "촬상소자", value: "1/ 2.8\" 2.1M Pixels Progressive Exmor Sensor" },
      { feature: "최소거리", value: "100mm~1200mm" },
      { feature: "S/N비", value: "54dB" },
      { feature: "최저조도", value: "0 Lux (IR LED ON)" },
      { feature: "초점 거리", value: "F=1.85 mm" },
      { feature: "초점 제어", value: "자동/수동 (네트워크를 통한 원격제어)" },
      { feature: "자동초점 (Auto Exposure)", value: "YES" },
      { feature: "디지털 줌", value: "8x" },
      { feature: "OSD", value: "Off/ON" },
      { feature: "Flip/Mirror", value: "Off/On" },
      { feature: "노출(AE)", value: "자동/수동" },
      { feature: "셔터속도", value: "1/10000 ~ 1/30 (sec)" },
      { feature: "자동 조리개", value: "Off/On" },
      { feature: "Auto Flicker-less", value: "Off/On" },
      { feature: "색 온도(AWB)", value: "자동(실내,실외), 그늘, 쾌청한 하늘, 형광등, 백열등, 불꽃, 수동" },
      { feature: "Day & Night", value: "자동/주간/야간/외부신호" },
      { feature: "WDR,BLC,HLC,DNR", value: "Off/On" },
      { feature: "안개보정(Defog)", value: "Off/On/Auto" },
      { feature: "세로모드", value: "Off/On (90도, 270도)" },
      { feature: "LDC 경계선", value: "Off/On" },
      { feature: "사생활 보호(Privacy Mask)", value: "8개 영역 지정가능" },
      { feature: "움직임 감지(Motion Detection)", value: "4개 Mask, 4개 Detection 지정가능" },
      { feature: "이벤트 감지", value: "알람 입력,부팅감지,수동 트리거,네트워크감지" },
      { feature: "이벤트 동작", value: "알람 출력" },
      { feature: "화면 가림 감지(Temper)", value: "Off/On" },
      { feature: "야간가시거리", value: "IR LED : 24개" },
      { feature: "압축방식", value: "H.264/H265(High, Main ,Baseline Profile), MJPEG" },
      { feature: "해상도", value: "1920x1080, 1280x1024, 1280x720, 704x576, 704x480, 640x480, 640x360, 320x240" },
      { feature: "최대 프레임 레이트", value: "최대 30fps@ 1920x1080" },
      { feature: "압축방식", value: "G.711 ADPCM a-Law/u-Law" },
      { feature: "통신", value: "양방향" },
      { feature: "입력(option)", value: "1Line-In" },
      { feature: "출력(option)", value: "1Line-Out" },
      { feature: "이더넷", value: "RJ-45(10/100BASE-T)" },
      { feature: "비트 레이트", value: "100 ~ 12000Kbps" },
      { feature: "IP", value: "IPv4, IPv6" },
      { feature: "Protocol", value: "TCP/IP,UDP/IP,RTP,RTSP,HTTP,HTTPS,SMTP,FTP,DHCP,UPnP ,Zeroconf, DNS,DDNS" },
      { feature: "보안", value: "HTTPS암호화,사용자 관리, IP주소 필터링" },
      { feature: "FTP Uploading", value: "MJPEG Stil Image" },
      { feature: "최대 동시 접속자", value: "10" },
      { feature: "S/W 응용 인터페이스", value: "Onvif profile S, ..." },
      { feature: "지원OS", value: "Windows Vista(32bit)/7/8" },
      { feature: "지원 웹브라우져", value: "MicroSoft Internet Explorer Ver.9, 10, Apple Safari Ver.4.0(Plug-in free viewer only), Google Chrome Ver.4.0(Plug-in free viewer only)" },
      { feature: "웹 언어", value: "한국어, English, 러시아어,일본어" },
      { feature: "동작온도/습도", value: "-20°C ~ 50°C / 90% RH 이하" },
      { feature: "방진/방수", value: "IP66" },
      { feature: "조절", value: "조절기능 ." },
      { feature: "사용전원/소비전류", value: "DC12V, PoE(IEEE802.3af) / 1A(Max)" },
      { feature: "재질/색상", value: "Aluminum / Ivory" },
      { feature: "중량", value: "480g" },
      { feature: "외 형 치 수", value: "104(Ø) x 91(H)mm" },
      ],
    relatedProducts: [
      { id: "tnc-fv120f", badges: ["Network","Fisheye","12M"] },
      { id: "tnc-d210v21af", badges: ["Network","IR","2M"] },
      { id: "tnc-d210v21afs", badges: ["Network","IR","2M"] },
      { id: "tnc-d210v30afs", badges: ["Network","IR","2M"] },
      { id: "tnc-d510v21af", badges: ["Network","IR","5M"] },
      { id: "utc-800dr", badges: ["UTC","IR","4K 8M"] },
    ],
  },
  // UTC-800DR
  {
    id: "utc-800dr",
    model: "UTC-800DR",
    category: "dome",
    categoryLabel: "Dome",
    description: "4K 8M IR Camera",
    aiSummary: "4K 800만 화소 고해상도 HD 적외선(IR) 돔 카메라로, AHD/TVI/CVI/CVBS 다중 출력을 지원하는 아날로그 전용 모델입니다. 기존 DVR 환경에서 고해상도 업그레이드가 필요한 실내 감시에 적합합니다.",
    allProductsImageKey: "Dome/TNC-D210V21AF",
    images: [
      { key: "Dome/TNC-D210V21AF", isDefault: true },
      { key: "Dome/TNC-FV120F", isDefault: false },
      { key: "Dome/TNC-V210F18", isDefault: false },
      { key: "Dome/TNC-D210V30AFS", isDefault: false },
    ],
    badges: [
      { text: "UTC", colorScheme: "green" },
      { text: "IR", colorScheme: "red" },
      { text: "4K 8M", colorScheme: "blue" },
    ],
    keyFeatures: [
      "4K 고해상도  HD IR 카메라 (3840x2160 15fps)",
      "1/2.5 “8  M Pixels Progressive  Exmor Sensor",
      "F=3.6mm",
      "Multi  해상도 지원 (2M/4M/5M/8M)",
      "AHD (TVI/CVI/CVBS)",
      "D-WDR 지원",
      "Privacy Mask 8 Area 기능",
      "2D, 3D 잡음제거 설정 가능",
      "SMART IR 설정 지원",
      "UTC(UP TO COAX)",
      "OSD 제어 케이블 (옵션)",
    ],
    specs: [
      { feature: "유효화소", value: "3840(H) x 2160(V)" },
      { feature: "촬상소자", value: "1/2.5\" 8M Pixels Progressive Exmor Sensor" },
      { feature: "최소거리", value: "100mm~1200mm" },
      { feature: "S/N비", value: "54dB" },
      { feature: "최저조도", value: "주간: 0.01Lux, 야간: 0 Lux (IR LED ON)" },
      { feature: "초점 거리", value: "F-3.6mm" },
      { feature: "초점 제어", value: "고정" },
      { feature: "해상도", value: "2592X1944(20fps), 2688x1520(30fps), 1920x1080(30fps)" },
      { feature: "LSC(Lens Shading Correction)", value: "고정" },
      { feature: "OSD", value: "지원" },
      { feature: "Flip/Mirror", value: "Adjust" },
      { feature: "노출(AE)", value: "Adjust" },
      { feature: "셔터속도", value: "1/10000 ~ 1/30 (sec)" },
      { feature: "자동 조리개", value: "고정" },
      { feature: "Auto Flicker-less", value: "Adjust" },
      { feature: "색 온도(AWB)", value: "자동(실내,실외), 그늘, 쾌청한 하늘, 형광등, 백열등, 불꽃, 수동" },
      { feature: "Day & Night", value: "자동/주간/야간/외부신호 _고정" },
      { feature: "AE,BLC,HLC,DNR", value: "Adjust" },
      { feature: "안개보정(Defog)", value: "Adjust" },
      { feature: "사생활 보호(Privacy Mask)", value: "Adjust" },
      { feature: "움직임 감지(Motion Detection)", value: "Adjust" },
      { feature: "적외선 LED", value: "21EA" },
      { feature: "영상출력", value: "AHD (TVI/CVI/CVBS)" },
      { feature: "전원 입력", value: "DC JACK" },
      { feature: "영상출력", value: "BNC CVBS (옵션)" },
      { feature: "EXT OSD", value: "OSD KEY (옵션)" },
      { feature: "동작온도/습도", value: "-20°C ~ 50°C / 90% RH 이하" },
      { feature: "조절", value: "3축 조절기능" },
      { feature: "사용전원/소비전류", value: "DC12V, / 350mA(Max)" },
      { feature: "중량", value: "430 g" },
      { feature: "외 형 치 수", value: "127mm(W) x 92mm(H)" },
      { feature: "방진/방수", value: "x" },
      { feature: "충격대응", value: "x" },
      ],
    relatedProducts: [
      { id: "tnc-fv120f", badges: ["Network","Fisheye","12M"] },
      { id: "tnc-v210f18", badges: ["Network","IR","2M"] },
      { id: "tnc-d210v21af", badges: ["Network","IR","2M"] },
      { id: "tnc-d210v21afs", badges: ["Network","IR","2M"] },
      { id: "tnc-d210v30afs", badges: ["Network","IR","2M"] },
      { id: "tnc-d510v21af", badges: ["Network","IR","5M"] },
    ],
  },
  // TNC-BP21V36AFS
  {
    id: "tnc-bp21v36afs",
    isNew: true,
    model: "TNC-BP21V36AFS",
    category: "ptz",
    categoryLabel: "PTZ",
    description: "2M IR Camera",
    aiSummary: "200만 화소 네트워크 PTZ 카메라로, 36배율 고성능 줌 렌즈를 장착한 전문 감시 모델입니다. 255개 프리셋 위치 지정, 투어 경로, 클린 와이퍼 기본 장착 등 다양한 기능을 제공하며, 도시 감시, 교차로, 대형 시설 등 광범위한 구역의 정밀 감시에 적합합니다.",
    allProductsImageKey: "Ptz/TNC-SPT2M-36AF",
    images: [
      { key: "Ptz/PTZ_1", isDefault: false },
      { key: "Ptz/TNC-BP516AFS", isDefault: false },
      { key: "Ptz/TNC-SPT2M-36AF", isDefault: true },
      { key: "Ptz/TNC-VS210AFS", isDefault: false },
    ],
    badges: [
      { text: "Network", colorScheme: "green" },
      { text: "IR", colorScheme: "red" },
      { text: "2M", colorScheme: "blue" },
    ],
    keyFeatures: [
      "200만 화소 네트워크 PTZ 카메라(1920x1080P @ 60fps)",
      "H.265 / H.264 / MJPEG  Triple 스트리밍 지원  , AMBA  SOC 적용",
      "1/2” SONY CMOS 이미지 센서_IMX385",
      "Built In X36  전용 AF ZOOM  (5.8~210mmAF)",
      "WDR(Wide Dynamic Range)",
      "DNR(Digital Noise Reduction)",
      "프리셋 위치 지정 255 및 TOUR 8",
      "움직임 감지 기능",
      "양 뱡향 오디오 지원 및 RS-485 제어가능",
      "로컬 저장을 위한  메모리 카드 슬롯 내장",
      "클린 와이퍼 기본장착",
      "FAN & HITTER 내장",
      "IP66",
    ],
    specs: [
      { feature: "유효화소수", value: "1944(H) x 1092(V) = 2.12M Pixels" },
      { feature: "방송방식", value: "NTSC Standard: 525 Line, 30 Frames/Sec" },
      { feature: "촬상소자", value: "2.0 Mega Pixels 1/2” SONY CMOS 이미지센서" },
      { feature: "S/N비", value: "120dB" },
      { feature: "최저조도", value: "1. COLOR: 0.01 lux / DSS 0.001 lux, 2. BW: 0.002 lux / DSS 0.0002 lux, 3. IRLED: 0 lux" },
      { feature: "고 휘도 IR LED", value: "6EA (근접: 3EA, 원거리: 3EA), IR 가시거리: 80~140m" },
      { feature: "렌즈 줌 배율", value: "X36" },
      { feature: "초점 거리", value: "5.8~210 mm" },
      { feature: "구경비", value: "F1.5±5%(Wide) ~ F4.8±5%(Tele)" },
      { feature: "화각 (D / H / V)", value: "H56.5°(W) ~ V33.6°(W)" },
      { feature: "영상 출력", value: "NETWORK, CVBS(Test Only)" },
      { feature: "압축방식", value: "Main Stream: H.265/H.264, Secondary Stream: H.264/MPEG-4/MJPEG" },
      { feature: "전송 프레임", value: "Tripple Streaming H.264/MPEG-4/MJPEG" },
      { feature: "입력", value: "1Line-In" },
      { feature: "출력", value: "1Line-Out" },
      { feature: "프리셋 설정 수", value: "255개" },
      { feature: "프리셋 속도 가변 지정", value: "Adjust" },
      { feature: "프리셋 이름 개별 설정 기능", value: "Yes" },
      { feature: "프리셋 Pan/Tilt속도", value: "Pan 0~360°, Tilt -35~+25°/Sec 가변설정가능" },
      { feature: "투어 설정 수", value: "8개" },
      { feature: "회전 동작 범위", value: "0°~360° 연속회전(Pan) / -35°~+25°(Tilt)" },
      { feature: "최대 회전 속도", value: "Pan /Tilt 20° / Sec" },
      { feature: "파워 온 액션 기능", value: "Yes" },
      { feature: "Tour", value: "Yes" },
      { feature: "자동파킹 기능", value: "Yes" },
      { feature: "스윙, Preset 위치 설정", value: "Yes" },
      { feature: "센서 입/출력", value: "1 Input, 1 Output" },
      { feature: "정전복구 기능", value: "마지막 위치 기억" },
      { feature: "Tour, Vector, 줌 속도 기능", value: "Yes" },
      { feature: "데이터 메모리 백업 기능", value: "Yes" },
      { feature: "특정 영역 차단 기능(사생활보호)", value: "8개 영역 (On/Off)" },
      { feature: "Compression", value: "H.265/H.264 / MPEG-4 / MJPEG Triple Streaming" },
      { feature: "Resolution", value: "1080P, 720P, 4CIF, VGA, CIF, QVGA, QCIF, QQVGA" },
      { feature: "Bit Rate", value: "32Kbps ~ 20Mbps" },
      { feature: "Frame Rate", value: "60fps up to 1080p, 30/25(NTSC/PAL)fps @ all Resolution" },
      { feature: "Ethernet", value: "Ethernet 10/100 Base-T(RJ-45)" },
      { feature: "Audio", value: "Two way full duplex G.711 / G.726" },
      { feature: "Protocol", value: "TCP,IP, UDP, HTTP, DHCP, PPPoE, FTP, DNS, DDNS, NTP, ICMP, SNMP, SMTPE, UPnP, RTP, RTSP, ONVIF, GENETEC" },
      { feature: "ROI Encording", value: "Yes" },
      { feature: "Home Position 기능", value: "Yes" },
      { feature: "자체진단기능", value: "Yes" },
      { feature: "OSD", value: "Yes" },
      { feature: "동작온도/습도", value: "-10°C ~ 50°C / 0 ~ 90RH % 이하" },
      { feature: "재 질", value: "Dicasting (Body), 아크릴(Cover)" },
      { feature: "사 용 전 원", value: "DC12V 3A 60Hz /50Hz, W/POE" },
      { feature: "중 량", value: "4Kg (±1%)" },
      { feature: "외 형 치 수", value: "250(L) x 135(W) x 226(H)" },
      ],
    relatedProducts: [
      { id: "tnc-bp516afs", badges: ["Network","IR","5M"] },
      { id: "tnc-bp21v08afs", badges: ["Network","IR","2M"] },
      { id: "tnc-vs210af", badges: ["Network","IR","2M"] },
      { id: "tnc-vs210afs", badges: ["Network","IR","2M"] },
      { id: "tnc-vs510afs", badges: ["Network","IR","5M"] },
    ],
  },
  // TNC-BP21V08AFS
  {
    id: "tnc-bp21v08afs",
    model: "TNC-BP21V08AFS",
    category: "ptz",
    categoryLabel: "PTZ",
    description: "2M IR Camera",
    aiSummary: "200만 화소 네트워크 PTZ 카메라로, 4배율 자동초점 줌 렌즈와 256개 프리셋을 지원합니다. SD 카드 로컬 녹화, 자동위치 보정 기능을 탑재하고 있으며, 중소형 구역의 실시간 이동 감시가 필요한 곳에 적합합니다.",
    allProductsImageKey: "Ptz/TNC-SPT2M-36AF",
    images: [
      { key: "Ptz/PTZ_1", isDefault: false },
      { key: "Ptz/TNC-BP516AFS", isDefault: false },
      { key: "Ptz/TNC-SPT2M-36AF", isDefault: true },
      { key: "Ptz/TNC-VS210AFS", isDefault: false },
    ],
    badges: [
      { text: "Network", colorScheme: "green" },
      { text: "IR", colorScheme: "red" },
      { text: "2M", colorScheme: "blue" },
    ],
    keyFeatures: [
      "200만 화소 네트워크 PTZ 카메라(1920x1080P @ 60fps)",
      "H.265 / H.264 / MJPEG  Triple 스트리밍 지원  , AMBA  SOC 적용",
      "1/2” SONY CMOS 이미지 센서_IMX385",
      "Built In X4  전용 AF ZOOM  (3.5~14mmAF)",
      "WDR(Wide Dynamic Range)",
      "DNR(Digital Noise Reduction)",
      "프리셋 위치 지정 255 및 TOUR 8",
      "움직임 감지 기능",
      "양 뱡향 오디오 지원 및 RS-485 제어가능",
      "자동위치 보정 기능 탑재",
      "SD CARD 영상 녹화",
      "FAN & HITTER 내장",
      "IP66",
    ],
    specs: [
      { feature: "유효화소수", value: "1944(H) x 1092(V) = 2.12M Pixels" },
      { feature: "방송방식", value: "NTSC Standard: 525 Line, 30Frames/Sec" },
      { feature: "촬상소자", value: "2.0 Mega Pixels 1/2” SONY CMOS 이미지센서" },
      { feature: "최소거리", value: "10mm ~ 1000mm" },
      { feature: "S/N비", value: "50dB" },
      { feature: "최저조도", value: "0Lux(IR ON) Built in Super IR 120m" },
      { feature: "렌즈 줌 배율", value: "X4 (3.5~14mmAF)" },
      { feature: "신호 출력", value: "TO BE" },
      { feature: "초점 거리", value: "-" },
      { feature: "구경비", value: "F1.5±5%(Wide) ~ F4.8±5%(Tele)" },
      { feature: "화각 (D / H / V)", value: "H56.5°(W) ~ V33.6°(W)" },
      { feature: "압축방식", value: "Main Stream: H.265/H.264, Secondary Stream: H.264/MPEG-4/MJPEG" },
      { feature: "전송 프레임", value: "QUAD Streaming H.264 / MPEG-4 / MJPEG" },
      { feature: "입력", value: "1Line-In" },
      { feature: "출력", value: "1Line-Out" },
      { feature: "프리셋 설정 수", value: "256개" },
      { feature: "프리셋 속도 가변 지정", value: "저속, 중속, 고속 (360°/Sec)" },
      { feature: "프리셋 이름 개별 설정 기능", value: "On/Off" },
      { feature: "프리셋 Pan/Tilt속도", value: "Pan 0~360°, Tilt -35~25°/Sec" },
      { feature: "회전 동작 범위", value: "0°~360° 연속회전(Pan) / -35°~25°(Tilt)" },
      { feature: "최대 회전 속도", value: "속도 15°/8 최대" },
      { feature: "전원On/Off 데이터 제어", value: "Yes" },
      { feature: "Scan", value: "Yes" },
      { feature: "패턴 기능", value: "Yes" },
      { feature: "스윙, Preset 위치 설정", value: "Yes" },
      { feature: "센서 입/출력", value: "1 Input, 1 Relay Output" },
      { feature: "정전복구 기능", value: "마지막 위치 기억" },
      { feature: "Tour 기능", value: "Yes" },
      { feature: "Tour, Vector, 줌 속도 기능", value: "Yes" },
      { feature: "데이터 메모리 백업 기능(option)", value: "Yes" },
      { feature: "FAN", value: "Yes" },
      { feature: "인증서", value: "Yes" },
      { feature: "특정 영역 차단 기능(사생활보호)", value: "8개 영역 (On/Off)" },
      { feature: "Compression", value: "H.265/H.264 / MPEG-4 / MJPEG Triple Streaming" },
      { feature: "Resolution", value: "1080P, 720P, 4CIF, VGA, CIF, QVGA, QCIF, QQVGA" },
      { feature: "Bit Rate", value: "32Kbps ~ 20Mbps" },
      { feature: "Frame Rate", value: "60fps up to 1080p, 30/25(NTSC/PAL)fps @ all Resolution" },
      { feature: "Ethernet", value: "Ethernet 10/100 Base-T(RJ-45)" },
      { feature: "Audio", value: "Two way full duplex G.711 / G.726" },
      { feature: "Protocol", value: "TCP,IP, UDP, HTTP, DHCP, PPPoE, FTP, DNS, DDNS, NTP, ICMP, SNMP, SMTPE, UPnP, RTP, RTSP, ONVIF, GENETEC" },
      { feature: "ROI Encording", value: "Yes" },
      { feature: "Home Position 기능", value: "Yes" },
      { feature: "자체진단기능", value: "Yes" },
      { feature: "동작온도/습도", value: "-10°C ~ 50°C / 0 ~ 90RH % 이하" },
      { feature: "재 질", value: "Dicasting (Body), 아크릴(Cover)" },
      { feature: "사 용 전 원", value: "AC24V 1.5A 60Hz PoE 30W" },
      { feature: "중 량", value: "4Kg (±1%)" },
      { feature: "외 형 치 수", value: "250(L) x 135(W) x 226(H)" },
      ],
    relatedProducts: [
      { id: "tnc-bp516afs", badges: ["Network","IR","5M"] },
      { id: "tnc-bp21v36afs", badges: ["Network","IR","2M"] },
      { id: "tnc-vs210af", badges: ["Network","IR","2M"] },
      { id: "tnc-vs210afs", badges: ["Network","IR","2M"] },
      { id: "tnc-vs510afs", badges: ["Network","IR","5M"] },
    ],
  },
  // TNC-BP516AFS
  {
    id: "tnc-bp516afs",
    isNew: true,
    model: "TNC-BP516AFS",
    category: "ptz",
    categoryLabel: "PTZ",
    description: "5M IR Camera",
    aiSummary: "500만 화소 네트워크 PTZ 카메라로, 10배율 줌 렌즈를 장착한 TTA 인증 획득 모델입니다. 256개 프리셋, 투어, 파워온 액션 등 PTZ 전문 기능을 지원하며, 중거리에서 고해상도 이동 감시가 필요한 주차장, 단지 경계, 공항 등에 적합합니다.",
    allProductsImageKey: "Ptz/TNC-BP516AFS",
    images: [
      { key: "Ptz/PTZ_1", isDefault: false },
      { key: "Ptz/TNC-BP516AFS", isDefault: true },
      { key: "Ptz/TNC-SPT2M-36AF", isDefault: false },
      { key: "Ptz/TNC-VS210AFS", isDefault: false },
    ],
    badges: [
      { text: "TTA", colorScheme: "yellow" },
      { text: "Network", colorScheme: "green" },
      { text: "IR", colorScheme: "red" },
      { text: "5M", colorScheme: "blue" },
    ],
    keyFeatures: [
      "500만 화소 네트워크 PTZ 카메라(2592x1944P @ 30fps)",
      "H.265 / H.264 / MJPEG  Triple 스트리밍 지원",
      "1/2.8” SONY CMOS 이미지 센서_IMX335",
      "Built In X10 AF ZOOM  /  X4  (옵션)",
      "WDR(Wide Dynamic Range)",
      "DNR(Digital Noise Reduction)",
      "프리셋 위치 지정 255 및 TOUR 8",
      "움직임 감지 기능",
      "파워 온 액션,오토 파킹 지원",
      "IP66",
    ],
    specs: [
      { feature: "유효화소수", value: "2592(H) x 1944(V) = 5M Pixels" },
      { feature: "방송방식", value: "NTSC Standard: 525 Line, 30Frames/Sec" },
      { feature: "촬상소자", value: "5 Mega Pixels 1/2.8” SONY CMOS 이미지센서" },
      { feature: "S/N비", value: "54dB" },
      { feature: "최저조도", value: "1.COLOR: 0.01 lux / DSS 0.001 lux 2.BW:0.002 lux / DSS 0.0002 lux 3.IRLED: 0 lux" },
      { feature: "렌즈 줌 배율", value: "X10" },
      { feature: "초점 거리", value: "-" },
      { feature: "구경비", value: "5.0~50 mm / 2.8~12mm(옵션)" },
      { feature: "화각 (D / H / V)", value: "F1.5±5%(Wide) ~ F4.8±5%(Tele)" },
      { feature: "압축방식", value: "Main Stream: H.265/H.264, Secondary Stream: H.264/MPEG-4/MJPEG" },
      { feature: "전송 프레임", value: "Tripple Streaming H.264 / MPEG-4 / MJPEG" },
      { feature: "입력", value: "1Line-In" },
      { feature: "출력", value: "1Line-Out" },
      { feature: "프리셋 설정 수", value: "256개" },
      { feature: "프리셋 속도 가변 지정", value: "Adjust" },
      { feature: "프리셋 이름 개별 설정 기능", value: "Yes" },
      { feature: "프리셋 Pan/Tilt속도", value: "Pan 0~220°,Tilt -45~+40°/Sec 가변설정가능" },
      { feature: "회전 동작 범위", value: "0°~220° 연속회전(Pan) / -45°~+40°(Tilt)" },
      { feature: "최대 회전 속도", value: "0°~220° 연속회전(Pan) / -45°~+40°(Tilt)" },
      { feature: "파워 온 액션 기능", value: "Yes" },
      { feature: "Tour", value: "Yes" },
      { feature: "자동파킹 기능", value: "Yes" },
      { feature: "스윙, Preset 위치 설정", value: "Yes" },
      { feature: "정전복구 기능", value: "마지막 위치 기억" },
      { feature: "Tour, Vector, 줌 속도 기능", value: "Yes" },
      { feature: "데이터 메모리 백업 기능", value: "Yes" },
      { feature: "특정 영역 차단 기능(사생활보호)", value: "8개 영역 (On/Off)" },
      { feature: "Compression", value: "H.265/H.264 / MPEG-4 / MJPEG Triple Streaming" },
      { feature: "Resolution", value: "1080P, 720P, 4CIF, VGA, CIF, QVGA, QCIF, QQVGA" },
      { feature: "Bit Rate", value: "32Kbps ~ 20Mbps" },
      { feature: "Frame Rate", value: "60fps up to 1080p, 30/25(NTSC/PAL)fps @ all Resolution" },
      { feature: "Ethernet", value: "Ethernet 10/100 Base-T(RJ-45)" },
      { feature: "Audio", value: "Two way full duplex G.711 / G.726" },
      { feature: "Protocol", value: "TCP,IP, UDP, HTTP, DHCP, PPPoE, FTP, DNS, DDNS, NTP, ICMP, SNMP, SMTPE, UPnP, RTP, RTSP, ONVIF, GENETEC" },
      { feature: "ROI Encording", value: "Yes" },
      { feature: "Home Position 기능", value: "Yes" },
      { feature: "자체진단기능", value: "Yes" },
      { feature: "OSD", value: "Yes" },
      { feature: "동작온도/습도", value: "-10°C ~ 50°C / 0 ~ 90RH % 이하" },
      { feature: "재 질", value: "Dicasting (Body), 아크릴(Cover)" },
      { feature: "사 용 전 원", value: "DC12V 3A 60Hz /50Hz, W/POE(옵션)" },
      { feature: "중 량", value: "1.7Kg (±1%)" },
      { feature: "외 형 치 수", value: "117(L) x 307(W) x 184(H)" },
      { feature: "TTA HASH(SHA-256)", value: "78821d43ed7e6cb0f043d1af1e3f4b0a45aca9835409e04e9f82d0e5bb2d18e7" },
      ],
    relatedProducts: [
      { id: "tnc-bp21v08afs", badges: ["Network","IR","2M"] },
      { id: "tnc-bp21v36afs", badges: ["Network","IR","2M"] },
      { id: "tnc-vs210af", badges: ["Network","IR","2M"] },
      { id: "tnc-vs210afs", badges: ["Network","IR","2M"] },
      { id: "tnc-vs510afs", badges: ["Network","IR","5M"] },
    ],
  },
  // TNC-VS210AF
  {
    id: "tnc-vs210af",
    model: "TNC-VS210AF",
    category: "ptz",
    categoryLabel: "PTZ",
    description: "2M IR Camera",
    aiSummary: "200만 화소 네트워크 PTZ 카메라로, 브래킷을 포함한 컴팩트한 설계의 스피드 돔 모델입니다. 190개 프리셋, 오토파킹, 파워온 액션을 지원하며, 소형이면서도 PTZ 기능이 필요한 실내외 감시 구역에 적합합니다.",
    allProductsImageKey: "Ptz/TNC-VS210AFS",
    images: [
      { key: "Ptz/PTZ_1", isDefault: false },
      { key: "Ptz/TNC-BP516AFS", isDefault: false },
      { key: "Ptz/TNC-SPT2M-36AF", isDefault: false },
      { key: "Ptz/TNC-VS210AFS", isDefault: true },
    ],
    badges: [
      { text: "Network", colorScheme: "green" },
      { text: "IR", colorScheme: "red" },
      { text: "2M", colorScheme: "blue" },
    ],
    keyFeatures: [
      "200만 화소 네트워크 PTZ 카메라(1920x1080P @ 30fps)",
      "H.265 / H.264 /MJPEG  Triple 스트리밍 지원",
      "1/ 2.8” SONY CMOS 이미지 센서",
      "WDR(Wide Dynamic Range)",
      "DNR(Digital Noise Reduction)",
      "프리셋 위치 지정 및 TOUR (옵션)",
      "움직임 감지 기능",
      "파워 온 액션,오토 파킹 지원",
      "양뱡향 오디오 지원 및 SDCARD (OPTION)",
      "W / Bracket",
      "IP66",
    ],
    specs: [
      { feature: "유효화소수", value: "1944(H) x 1092(V) = 2.12M Pixels" },
      { feature: "방송방식", value: "NTSC Standard: 525 Line, 30Frames/Sec" },
      { feature: "촬상소자", value: "2.0 Mega Pixels 1/2.8” SONY CMOS 이미지센서" },
      { feature: "S/N비", value: "54dB" },
      { feature: "최저조도", value: "1.COLOR: 0.01 lux / DSS 0.001 lux, 2.BW: 0.002 lux / DSS 0.0002 lux, 3.IRLED: 0 lux IR 20m" },
      { feature: "렌즈 줌 배율", value: "X4.2" },
      { feature: "초점 거리", value: "2.8~12mmAF" },
      { feature: "구경비", value: "F1.6(wide) ~ F3.5(tele)" },
      { feature: "화각 (D / H / V)", value: "Wide 62.7° / 55.4° / 32.6°, Tele 3.3° / 2.9° / 1.6°" },
      { feature: "압축방식", value: "Main Stream: H.265/H.264, Secondary Stream: H.264/MPEG-4/MJPEG" },
      { feature: "전송 프레임", value: "Triple Streaming H.264 / MPEG-4 / MJPEG" },
      { feature: "입력", value: "1Line-In" },
      { feature: "출력", value: "1Line-Out" },
      { feature: "프리셋 설정 수", value: "190개" },
      { feature: "프리셋 속도 가변 지정", value: "Adjust" },
      { feature: "프리셋 이름 개별 설정 기능", value: "Yes" },
      { feature: "프리셋 Pan/Tilt속도", value: "Pan 0~355°, Tilt 0~90°/Sec가변설정가능" },
      { feature: "회전 동작 범위", value: "0°~355° 연속회전(Pan) / 0°~90°(Tilt)" },
      { feature: "최대 회전 속도", value: "Pan 355° / Sec" },
      { feature: "파워 온 액션 기능", value: "Yes" },
      { feature: "스윙, Preset 위치 설정", value: "Yes" },
      { feature: "오토파킹 기능", value: "Yes" },
      { feature: "P/T 속도 기능", value: "Yes" },
      { feature: "특정 영역 차단 기능(사생활보호)", value: "8개 영역 (On/Off)" },
      { feature: "디지털 줌", value: "x16" },
      { feature: "Flip/Mirror", value: "Off/on" },
      { feature: "자동 촛점(Auto Exposure)", value: "Yes" },
      { feature: "셔터속도", value: "1/10000 ~ 1/30 (sec)" },
      { feature: "Auto Flicker-less", value: "Off/on" },
      { feature: "WDR,BLC,HLC,DNR", value: "Off/on" },
      { feature: "안개 보정(Defog)", value: "Off/on" },
      { feature: "Compression", value: "H.265/H.264 / MPEG-4 / MJPEG Triple Streaming" },
      { feature: "Resolution", value: "1080P, 720P, 4CIF, VGA, CIF, QVGA, QCIF, QQVGA" },
      { feature: "Bit Rate", value: "32Kbps ~ 20Mbps" },
      { feature: "Frame Rate", value: "30fps up to 1080p, 30/25(NTSC/PAL)fps @ all Resolution" },
      { feature: "Ethernet", value: "Ethernet 10/100 Base-T(RJ-45)" },
      { feature: "Audio (option)", value: "Two way full duplex G.711 / G.726" },
      { feature: "Protocol", value: "TCP,IP, UDP, HTTP, DHCP, PPPoE, FTP, DNS, DDNS, NTP, ICMP, SNMP, SMTPE, UPnP, RTP, RTSP, ONVIF, GENETEC" },
      { feature: "ROI Encording", value: "Yes" },
      { feature: "Home Position 기능", value: "Yes" },
      { feature: "자체진단기능", value: "Yes" },
      { feature: "OSD", value: "Yes" },
      { feature: "동작온도/습도", value: "-10°C ~ 50°C / 0 ~ 90RH % 이하" },
      { feature: "재 질", value: "Dicasting (Body), 아크릴(Cover)" },
      { feature: "사 용 전 원", value: "DC12V 2A 60Hz/50Hz, PoE" },
      { feature: "중 량", value: "650g (±1%)" },
      { feature: "외 형 치 수", value: "130mm(Ø) x 117(H) mm" },
      ],
    relatedProducts: [
      { id: "tnc-bp516afs", badges: ["Network","IR","5M"] },
      { id: "tnc-bp21v36afs", badges: ["Network","IR","2M"] },
      { id: "tnc-bp21v08afs", badges: ["Network","IR","2M"] },
      { id: "tnc-vs210afs", badges: ["Network","IR","2M"] },
      { id: "tnc-vs510afs", badges: ["Network","IR","5M"] },
    ],
  },
  // TNC-VS210AFS
  {
    id: "tnc-vs210afs",
    model: "TNC-VS210AFS",
    category: "ptz",
    categoryLabel: "PTZ",
    description: "2M IR Camera",
    aiSummary: "200만 화소 네트워크 PTZ 카메라로, 줌 렌즈를 탑재하고 절대좌표(방위각) 자동 표출 기능을 제공합니다. 브래킷 포함 컴팩트 디자인으로 설치가 용이하며, 방위각 표시가 필요한 방범 감시, 소형 시설 외곽 감시 등에 적합합니다.",
    allProductsImageKey: "Ptz/TNC-VS210AFS",
    images: [
      { key: "Ptz/PTZ_1", isDefault: false },
      { key: "Ptz/TNC-BP516AFS", isDefault: false },
      { key: "Ptz/TNC-SPT2M-36AF", isDefault: false },
      { key: "Ptz/TNC-VS210AFS", isDefault: true },
    ],
    badges: [
      { text: "Network", colorScheme: "green" },
      { text: "IR", colorScheme: "red" },
      { text: "2M", colorScheme: "blue" },
    ],
    keyFeatures: [
      "200만 화소 네트워크 PTZ 카메라(1920x1080P @ 60fps)",
      "H.265 / H.264 /MJPEG Triple 스트리밍 지원",
      "1/2” SONY CMOS 이미지 센서_IMX385",
      "WDR(Wide Dynamic Range)",
      "DNR(Digital Noise Reduction)",
      "프리셋 위치 지정 및 TOUR (옵션)",
      "파워 온 액션,오토 파킹 지원",
      "양뱡향 오디오 지원 및 SDCARD (OPTION)",
      "W / Bracket",
      "IP66",
    ],
    specs: [
      { feature: "유효화소수", value: "1944(H) x 1092(V) = 2.12M Pixels" },
      { feature: "방송방식", value: "NTSC Standard: 525 Line, 30Frames/Sec" },
      { feature: "촬상소자", value: "2.0 Mega Pixels 1/2” SONY CMOS 이미지센서" },
      { feature: "최소거리", value: "10mm ~ 1000mm" },
      { feature: "S/N비", value: "50dB" },
      { feature: "최저조도", value: "0Lux(IR ON) Built in Super IR 20m" },
      { feature: "렌즈 줌 배율", value: "X3.0" },
      { feature: "초점 거리", value: "3.6~11mm // 6~22mmAF" },
      { feature: "구경비", value: "F1.6(wide) ~ F3.5(tele)" },
      { feature: "화각 (D / H / V)", value: "Wide 62.7° / 55.4° / 32.6°, Tele 3.3° / 2.9° / 1.6°" },
      { feature: "압축방식", value: "Main Stream: H.265/H.264, Secondary Stream: H.264/MPEG-4/MJPEG" },
      { feature: "전송 프레임", value: "QUAD Streaming H.264 / MPEG-4 / MJPEG" },
      { feature: "입력", value: "1Line-In" },
      { feature: "출력", value: "1Line-Out" },
      { feature: "프리셋 설정 수", value: "190개" },
      { feature: "프리셋 속도 가변 지정", value: "저속, 중속, 고속 (360°/Sec)" },
      { feature: "프리셋 이름 개별 설정 기능", value: "On/Off" },
      { feature: "프리셋 Pan/Tilt속도", value: "Pan 0~355°, Tilt 0~90°/Sec가변설정가능" },
      { feature: "회전 동작 범위", value: "0°~355° 연속회전(Pan) / 0°~90°(Tilt)" },
      { feature: "최대 회전 속도", value: "Pan 355° / Sec" },
      { feature: "충격 감지 센서 (option)", value: "x" },
      { feature: "전원On/Off 데이터 제어", value: "Yes(OSD Menu)" },
      { feature: "Scan", value: "x" },
      { feature: "패턴 기능", value: "x" },
      { feature: "스윙, Preset 위치 설정", value: "Yes" },
      { feature: "센서 입/출력(option)", value: "1 Input Output1" },
      { feature: "정전복구 기능", value: "마지막 위치 기억" },
      { feature: "Group 기능", value: "x" },
      { feature: "Tour, Vector, 줌 속도 기능", value: "x" },
      { feature: "데이터 메모리 백업 기능(option)", value: "Yes" },
      { feature: "FAN (option)", value: "x" },
      { feature: "인증서", value: "YES" },
      { feature: "특정 영역 차단 기능(사생활보호)", value: "8개 영역 (On/Off)" },
      { feature: "절대좌표 (방위각)표출", value: "1°~355° 방위 자동 표출 기능(On/Off)" },
      { feature: "Compression", value: "H.265/H.264 / MPEG-4 / MJPEG Triple Streaming" },
      { feature: "Resolution", value: "1080P, 720P, 4CIF, VGA, CIF, QVGA, QCIF, QQVGA" },
      { feature: "Bit Rate", value: "32Kbps ~ 20Mbps" },
      { feature: "Frame Rate", value: "60fps up to 1080p, 30/25(NTSC/PAL)fps @ all Resolution" },
      { feature: "Ethernet", value: "Ethernet 10/100 Base-T(RJ-45)" },
      { feature: "Audio", value: "Two way full duplex G.711 / G.726" },
      { feature: "Protocol", value: "TCP,IP, UDP, HTTP, DHCP, PPPoE, FTP, DNS, DDNS, NTP, ICMP, SNMP, SMTPE, UPnP, RTP, RTSP, ONVIF, GENETEC" },
      { feature: "ROI Encording", value: "Yes" },
      { feature: "Home Position 기능", value: "Yes" },
      { feature: "자체진단기능", value: "Yes" },
      { feature: "OSD", value: "Yes" },
      { feature: "동작온도/습도", value: "-10°C ~ 50°C / 0 ~ 90RH % 이하" },
      { feature: "재질", value: "Dicasting (Body), 아크릴(Cover)" },
      { feature: "사용 전원", value: "DC12V 2A 60Hz PoE(40V인젝트지원)" },
      { feature: "중량", value: "450g (±1%)" },
      { feature: "외형 치수", value: "130mm(Ø) x 117(H) mm" },
      ],
    relatedProducts: [
      { id: "tnc-bp516afs", badges: ["Network","IR","5M"] },
      { id: "tnc-bp21v36afs", badges: ["Network","IR","2M"] },
      { id: "tnc-bp21v08afs", badges: ["Network","IR","2M"] },
      { id: "tnc-vs210af", badges: ["Network","IR","2M"] },
      { id: "tnc-vs510afs", badges: ["Network","IR","5M"] },
    ],
  },
  // TNC-VS510AFS
  {
    id: "tnc-vs510afs",
    isNew: true,
    model: "TNC-VS510AFS",
    category: "ptz",
    categoryLabel: "PTZ",
    description: "5M IR Camera",
    aiSummary: "500만 화소 네트워크 PTZ 카메라로, 4배율 줌 렌즈를 장착한 고해상도 스피드 돔 모델입니다. 190개 프리셋과 절대좌표 방위각 표출 기능을 지원하며, 고해상도와 PTZ 기능이 동시에 필요한 중소형 감시 구역에 적합합니다.",
    allProductsImageKey: "Ptz/TNC-VS210AFS",
    images: [
      { key: "Ptz/PTZ_1", isDefault: false },
      { key: "Ptz/TNC-BP516AFS", isDefault: false },
      { key: "Ptz/TNC-SPT2M-36AF", isDefault: false },
      { key: "Ptz/TNC-VS210AFS", isDefault: true },
    ],
    badges: [
      { text: "Network", colorScheme: "green" },
      { text: "IR", colorScheme: "red" },
      { text: "5M", colorScheme: "blue" },
    ],
    keyFeatures: [
      "500만 화소 네트워크 PTZ 카메라(2592x1944P @ 30fps)",
      "X 4 배 광학 (2.7~13.5mmAF)",
      "H.265 / H.264 /MJPEG Triple 스트리밍 지원",
      "1/2.8” SONY CMOS 이미지 센서",
      "WDR(Wide Dynamic Range)",
      "DNR(Digital Noise Reduction)",
      "프리셋 위치 지정 및 TOUR (옵션)",
      "파워 온 액션,오토 파킹 지원",
      "양뱡향 오디오 지원 및 SDCARD (OPTION)",
      "W / Bracket",
      "IP66",
    ],
    specs: [
      { feature: "유효화소수", value: "2592(H) x 1944(V)" },
      { feature: "방송방식", value: "NTSC Standard: 525 Line, 30Frames/Sec" },
      { feature: "촬상소자", value: "5.69 Mega Pixels 1/2.8” SONY CMOS 이미지센서" },
      { feature: "최소거리", value: "10mm ~ 1000mm" },
      { feature: "S/N비", value: "50dB" },
      { feature: "최저조도", value: "0Lux(IR ON) Built in Super IR 20" },
      { feature: "렌즈 줌 배율", value: "X4" },
      { feature: "초점 거리", value: "2.8~12mmAF" },
      { feature: "구경비", value: "F1.6(wide) ~ F3.5(tele)" },
      { feature: "화각 (D / H / V)", value: "Wide 62.7° / 55.4° / 32.6°, Tele 3.3° / 2.9° / 1.6°" },
      { feature: "압축방식", value: "Main Stream: H.265/H.264, Secondary Stream: H.264/MPEG-4/MJPEG" },
      { feature: "전송 프레임", value: "Quad Streaming H.264/ H265/ MPEG-4 / MJPEG" },
      { feature: "입력", value: "1Line-In" },
      { feature: "출력", value: "1Line-Out" },
      { feature: "프리셋 설정 수", value: "190 개" },
      { feature: "프리셋 속도 가변 지정", value: "저속, 중속, 고속 (360°/Sec)" },
      { feature: "프리셋 이름 개별 설정 기능", value: "On/Off" },
      { feature: "프리셋 Pan/Tilt속도", value: "Pan 0~355°, Tilt 0~90°/Sec가변설정가능" },
      { feature: "회전 동작 범위", value: "0°~355° 연속회전(Pan) / 0°~90°(Tilt)" },
      { feature: "최대 회전 속도", value: "Pan 355° / Sec" },
      { feature: "충격 감지 센서 (option)", value: "x" },
      { feature: "전원On/Off 데이터 제어", value: "Yes(OSD Menu)" },
      { feature: "Scan", value: "x" },
      { feature: "패턴 기능", value: "x" },
      { feature: "스윙, Preset 위치 설정", value: "Yes" },
      { feature: "센서 입/출력(option)", value: "1 Input 1Relay Output" },
      { feature: "정전복구 기능", value: "마지막 위치 기억" },
      { feature: "Group 기능", value: "x" },
      { feature: "Tour, Vector, 줌 속도 기능", value: "x" },
      { feature: "데이터 메모리 백업 기능(option)", value: "Yes" },
      { feature: "FAN (option)", value: "x" },
      { feature: "인증서", value: "YES" },
      { feature: "특정 영역 차단 기능(사생활보호)", value: "8개 영역 (On/Off)" },
      { feature: "절대좌표 (방위각)표출", value: "1°~355° 방위 자동 표출 기능(On/Off)" },
      { feature: "Compression", value: "H.265/H.264 / MPEG-4 / MJPEG Triple Streaming" },
      { feature: "Resolution", value: "2592, 1080P, 720P, 4CIF, VGA, CIF, QVGA, QCIF, QQVGA" },
      { feature: "Bit Rate", value: "32Kbps ~ 20Mbps" },
      { feature: "Frame Rate", value: "30fps up to 2592 p, 30/25(NTSC/PAL)fps @ all Resolution" },
      { feature: "Ethernet", value: "Ethernet 10/100 Base-T(RJ-45)" },
      { feature: "Audio", value: "Two way full duplex G.711 / G.726" },
      { feature: "Protocol", value: "TCP,IP, UDP, HTTP, DHCP, PPPoE, FTP, DNS, DDNS, NTP, ICMP, SNMP, SMTPE, UPnP, RTP, RTSP, ONVIF, GENETEC" },
      { feature: "ROI Encording", value: "Yes" },
      { feature: "Home Position 기능", value: "Yes" },
      { feature: "자체진단기능", value: "Yes" },
      { feature: "OSD", value: "Yes" },
      { feature: "동작온도/습도", value: "-10°C ~ 50°C / 0 ~ 90RH % 이하" },
      { feature: "재질", value: "Dicasting (Body), 아크릴(Cover)" },
      { feature: "사용 전원", value: "DC12V 2A 60Hz PoE(40V인젝트지원)" },
      { feature: "중량", value: "450g (±1%)" },
      { feature: "외형 치수", value: "130mm(Ø) x 117(H) mm" },
      ],
    relatedProducts: [
      { id: "tnc-bp516afs", badges: ["Network","IR","5M"] },
      { id: "tnc-bp21v36afs", badges: ["Network","IR","2M"] },
      { id: "tnc-bp21v08afs", badges: ["Network","IR","2M"] },
      { id: "tnc-vs210af", badges: ["Network","IR","2M"] },
      { id: "tnc-vs210afs", badges: ["Network","IR","2M"] },
    ],
  },
  // TNC-SD438AFS
  {
    id: "tnc-sd438afs",
    isNew: true,
    model: "TNC-SD438AFS",
    category: "speed-dome",
    categoryLabel: "Speed Dome",
    aiTags: ["iva", "object-detection", "event-thumbnail"],
    description: "4M AI IR PTZ Camera",
    aiSummary: "400만 화소 AI 기반 네트워크 적외선(IR) 스피드 돔 PTZ 카메라로, 38배 광학 줌과 최대 300m 적외선 야간 가시거리를 제공합니다. AI 객체 분석(사람, 차량, 자전거, 번호판) 기능을 탑재하고 있으며, IP66/IK10 인증으로 혹독한 환경에서도 작동합니다.",
    allProductsImageKey: "SpeedDome/TNC-SD438AFS",
    images: [
      { key: "SpeedDome/TNC-SD438AFS", isDefault: true },
    ],
    badges: [
      { text: "Network", colorScheme: "green" },
      { text: "IR", colorScheme: "red" },
      { text: "4M", colorScheme: "blue" },
      { text: "AI", colorScheme: "purple" },
    ],
    keyFeatures: [
      "고화질 4M IR 네트워크 PTZ 카메라 (2688x1520@60fps)",
      "1/1.8\" Sony Exmor CMOS sensor_IMX664",
      "38배 광학, 12배 디지털 줌 렌즈 탑재",
      "WDR(Wide Dynamic Range), DIS, Defog 지원",
      "DNR(2D+3D) 지원",
      "H.265 / H.264 / MJPEG Quad 스트리밍 지원",
      "WIPER 기본 장착으로 손쉬운 먼지 및 물기 제거",
      "햇볕이나 비, 눈을 가려주는 하우징 구조(porch)",
      "Day & Night 또는 CDS를 이용한 IR 동작 제어",
      "256 프리셋 위치 지정 및 Autoscan 16, Tour 8",
      "ROI Encoding 지원",
      "8EA IR LED 적용 IR 최대 거리 300M",
      "자동 위치 보정기능으로 물리적, 기구적 이동으로 인한 오차 보정",
      "양방향 오디오 지원",
      "IP66, IK10",
      "IVA (Intelligent Video Analytic) 지원",
      "객체분석: Person, Vehicle, Bike, License Plate",
    ],
    specs: [
      { feature: "총화소수", value: "2704(H) x 1560(V) 4.2M Pixels" },
      { feature: "유효화소", value: "2688(H) x 1520(V) 4M Pixels" },
      { feature: "촬상소자", value: "1/1.8\" Sony Exmor CMOS Sensor" },
      { feature: "Scanning system", value: "Progressive Scan" },
      { feature: "S/N비", value: "56dB 이상 (AGC off)" },
      { feature: "최저조도", value: "0lux(IR ON)" },
      { feature: "렌즈 줌 배율", value: "Optical x38, Digital x12 Zoom" },
      { feature: "신호 출력", value: "CVBS (Option)" },
      { feature: "Focal Length", value: "f=5.78mm ~ 220.4mm" },
      { feature: "Aperture Ratio", value: "F1.6(wide) ~ F4.9(tele)" },
      { feature: "Main Stream", value: "H.265/H.264/MJPEG" },
      { feature: "Other Stream", value: "H.264/MPEG-4/MJPEG" },
      { feature: "Resolutions", value: "2688x1520P ~ QCIF" },
      { feature: "오디오 입력", value: "1Line-In (G.711 / G.726)" },
      { feature: "오디오 출력", value: "1Line-Out (G.711 / G.726)" },
      { feature: "프리셋 설정 수", value: "256개" },
      { feature: "프리셋 속도 가변 지정", value: "저속, 중속, 고속 (360°/Sec)" },
      { feature: "프리셋 이름 개별 설정 기능", value: "On/Off" },
      { feature: "프리셋 Pan/Tilt 속도", value: "Pan 0~360°, Tilt 0~90°/Sec 가변설정가능" },
      { feature: "회전 동작 범위", value: "0°~360° 연속회전(Pan) / Tilt, -10~+90°" },
      { feature: "최대 회전 속도", value: "Pan (0.2°/s ~ 230°/s), Tilt (0.2°/s ~ 230°/s)" },
      { feature: "IR 최대 거리", value: "300M" },
      { feature: "IR 방사각도", value: "WIDE 60도, TELE 15도" },
      { feature: "WIPER", value: "Yes" },
      { feature: "안개 보정기능", value: "On/Off" },
      { feature: "움직임 기능", value: "Yes" },
      { feature: "AutoScan", value: "Yes" },
      { feature: "스윙, Preset 위치 설정", value: "Yes" },
      { feature: "센서 입/출력", value: "1Input 1Relay Output" },
      { feature: "정전복구 기능", value: "마지막 위치 기억" },
      { feature: "Tour 기능", value: "8 Group" },
      { feature: "인증", value: "KC, IP66, IK10, NIS 지원" },
      { feature: "Compression", value: "H.265/H.264/MPEG-4/MJPEG Quad Streaming & Jpeg" },
      { feature: "Resolution", value: "2688x1520(4M), 1920x1080, 1280x720, 1024x576, 768x432, 640x360" },
      { feature: "Bit Rate", value: "32Kbps ~ 10Mbps" },
      { feature: "Frame Rate", value: "60fps up to 2688x1520p" },
      { feature: "Ethernet", value: "Ethernet 10/100 Base-T(RJ-45)" },
      { feature: "Audio", value: "Two way full duplex G.711 / G.726" },
      { feature: "Protocol", value: "HTTP, RTP/RTSP, TCP/IP, UDP, FTP, Telnet, DHCP, PPPoE, DNS, NTP, ICMP, SNMP, UPnP, Bonjour, ZeroConf, ONVIF, Genetec" },
      { feature: "ROI Encoding", value: "Yes" },
      { feature: "Home Position 기능", value: "Yes" },
      { feature: "자체진단기능", value: "Yes" },
      { feature: "동작온도/습도", value: "-40°C ~ 70°C / 0 ~ 90RH % 이하" },
      { feature: "재질", value: "Aluminum, PLASTIC" },
      { feature: "사용 전원", value: "DC24V 40W 60Hz" },
      { feature: "중량", value: "6Kg (±2%)" },
      { feature: "외형 치수", value: "Ø226 x 365.5mm" },
    ],
    relatedProducts: [
      { id: "tnc-sd838afs", badges: ["Network","IR","4K","8M","AI"] },
    ],
  },
  // TNC-SD838AFS
  {
    id: "tnc-sd838afs",
    isNew: true,
    model: "TNC-SD838AFS",
    category: "speed-dome",
    categoryLabel: "Speed Dome",
    aiTags: ["iva", "object-detection", "event-thumbnail"],
    description: "4K 8M AI IR PTZ Camera",
    aiSummary: "4K 800만 화소 AI 기반 네트워크 적외선(IR) 스피드 돔 PTZ 카메라로, 38배 광학 줌과 최대 300m 적외선 야간 가시거리를 제공하는 최상급 모델입니다. AI 객체 분석 기능을 탑재하고 있어, 국경, 공항, 항만 등 최고 수준의 보안 감시가 필요한 곳에 적합합니다.",
    allProductsImageKey: "SpeedDome/TNC-SD838AFS",
    images: [
      { key: "SpeedDome/TNC-SD838AFS", isDefault: true },
    ],
    badges: [
      { text: "Network", colorScheme: "green" },
      { text: "IR", colorScheme: "red" },
      { text: "4K", colorScheme: "blue" },
      { text: "8M", colorScheme: "orange" },
      { text: "AI", colorScheme: "purple" },
    ],
    keyFeatures: [
      "고화질 4K 8M IR 네트워크 PTZ 카메라 (3840x2160@30fps)",
      "1/1.8\" Sony Exmor CMOS sensor_IMX678",
      "38배 광학, 12배 디지털 줌 렌즈 탑재",
      "WDR(Wide Dynamic Range), DIS, Defog 지원",
      "DNR(2D+3D) 지원",
      "H.265 / H.264 / MJPEG Quad 스트리밍 지원",
      "WIPER 기본 장착으로 손쉬운 먼지 및 물기 제거",
      "햇볕이나 비, 눈을 가려주는 하우징 구조(porch)",
      "Day & Night 또는 CDS를 이용한 IR 동작 제어",
      "256 프리셋 위치 지정 및 Autoscan 16, Tour 8",
      "ROI Encoding 지원",
      "8EA IR LED 적용 IR 최대 거리 300M",
      "자동 위치 보정기능으로 물리적, 기구적 이동으로 인한 오차 보정",
      "양방향 오디오 지원",
      "IP66, IK10",
      "IVA (Intelligent Video Analytic) 지원",
      "객체분석: Person, Vehicle, Bike, License Plate",
    ],
    specs: [
      { feature: "총화소수", value: "3840(H) x 2160(V) 8M Pixels" },
      { feature: "유효화소", value: "3856(H) x 2200(V) 8.48M Pixels" },
      { feature: "촬상소자", value: "1/1.8\" Sony Exmor CMOS Sensor" },
      { feature: "Scanning system", value: "Progressive Scan" },
      { feature: "S/N비", value: "56dB 이상 (AGC off)" },
      { feature: "최저조도", value: "0lux(IR ON)" },
      { feature: "렌즈 줌 배율", value: "Optical x38, Digital x12 Zoom" },
      { feature: "신호 출력", value: "CVBS (Option)" },
      { feature: "Focal Length", value: "f=5.78mm ~ 220.4mm" },
      { feature: "Aperture Ratio", value: "F1.6(wide) ~ F4.9(tele)" },
      { feature: "Main Stream", value: "H.265/H.264/MJPEG" },
      { feature: "Other Stream", value: "H.264/MPEG-4/MJPEG" },
      { feature: "Resolutions", value: "3840x2160P ~ QCIF" },
      { feature: "오디오 입력", value: "1Line-In (G.711 / G.726)" },
      { feature: "오디오 출력", value: "1Line-Out (G.711 / G.726)" },
      { feature: "프리셋 설정 수", value: "256개" },
      { feature: "프리셋 속도 가변 지정", value: "저속, 중속, 고속 (360°/Sec)" },
      { feature: "프리셋 이름 개별 설정 기능", value: "On/Off" },
      { feature: "프리셋 Pan/Tilt 속도", value: "Pan 0~360°, Tilt 0~90°/Sec 가변설정가능" },
      { feature: "회전 동작 범위", value: "0°~360° 연속회전(Pan) / Tilt, -10~+90°" },
      { feature: "최대 회전 속도", value: "Pan (0.2°/s ~ 230°/s), Tilt (0.2°/s ~ 230°/s)" },
      { feature: "IR 최대 거리", value: "300M" },
      { feature: "IR 방사각도", value: "WIDE 60도, TELE 15도" },
      { feature: "WIPER", value: "Yes" },
      { feature: "안개 보정기능", value: "On/Off" },
      { feature: "움직임 기능", value: "Yes" },
      { feature: "AutoScan", value: "Yes" },
      { feature: "스윙, Preset 위치 설정", value: "Yes" },
      { feature: "센서 입/출력", value: "1Input 1Relay Output" },
      { feature: "정전복구 기능", value: "마지막 위치 기억" },
      { feature: "Tour 기능", value: "8 Group" },
      { feature: "인증", value: "KC, IP66, IK10, NIS 지원" },
      { feature: "Compression", value: "H.265/H.264/MPEG-4/MJPEG Quad Streaming & Jpeg" },
      { feature: "Resolution", value: "2592x1944, 2048x1536, 1920x1080, 1280x720, 1024x576, 768x432, 640x360" },
      { feature: "Bit Rate", value: "32Kbps ~ 10Mbps" },
      { feature: "Frame Rate", value: "30fps up to 3840x2160p" },
      { feature: "Ethernet", value: "Ethernet 10/100 Base-T(RJ-45)" },
      { feature: "Audio", value: "Two way full duplex G.711 / G.726" },
      { feature: "Protocol", value: "HTTP, RTP/RTSP, TCP/IP, UDP, FTP, Telnet, DHCP, PPPoE, DNS, NTP, ICMP, SNMP, UPnP, Bonjour, ZeroConf, ONVIF, Genetec" },
      { feature: "ROI Encoding", value: "Yes" },
      { feature: "Home Position 기능", value: "Yes" },
      { feature: "자체진단기능", value: "Yes" },
      { feature: "동작온도/습도", value: "-40°C ~ 70°C / 0 ~ 90RH % 이하" },
      { feature: "재질", value: "Aluminum, PLASTIC" },
      { feature: "사용 전원", value: "DC24V 40W 60Hz" },
      { feature: "중량", value: "6Kg (±2%)" },
      { feature: "외형 치수", value: "Ø226 x 365.5mm" },
    ],
    relatedProducts: [
      { id: "tnc-sd438afs", badges: ["Network","IR","4M","AI"] },
    ],
  },
  // TNC-EF528AF
  {
    id: "tnc-ef528af",
    isNew: true,
    model: "TNC-EF528AF",
    category: "special",
    categoryLabel: "Special",
    description: "5M Network Fire Alarm Eyeball Camera",
    aiSummary: "500만 화소 네트워크 화재감지 아이볼 카메라로, 단파장 화염 감지 센서를 결합한 특수 목적 카메라입니다. 사파이어 렌즈를 장착해 고온 환경에서도 안정적으로 동작하며, 화재 감시와 일반 감시를 동시에 수행해야 하는 산업 현장, 임야 등에 적합합니다.",
    allProductsImageKey: "Special/TNC-V210V06AF",
    images: [
      { key: "Special/TNC-GB210V12AFS", isDefault: false },
      { key: "Special/TNC-V210V06AF", isDefault: true },
    ],
    badges: [
      { text: "Fire Alarm", colorScheme: "yellow" },
      { text: "Network", colorScheme: "green" },
      { text: "Eyeball", colorScheme: "red" },
      { text: "5M", colorScheme: "blue" },
    ],
    keyFeatures: [
      "500만 화소 네트워크 카메라(2592x1944P @ 30fps)",
      "H.265 / H.264 / MJPEG  Triple 스트리밍 지원",
      "1/2.8” SONY CMOS 이미지 센서_IMX335",
      "Built In Fixed Lens (2.8mm)/2.8~12mm(옵션)",
      "Sapphire Lens 장착",
      "양 뱡향 오디오 , ALARM OUT지원",
      "IP66",
    ],
    specs: [
      { feature: "유효화소", value: "2592(H) x 1944(V) (Full-HD)" },
      { feature: "촬상소자", value: "1/2.8\" 5M Pixels Progressive Exmor Sensor" },
      { feature: "최소거리", value: "100mm~1200mm" },
      { feature: "S/N비", value: "54dB" },
      { feature: "최저조도", value: "0 Lux (IR LED ON)" },
      { feature: "초점 거리", value: "2.8mm / 2.8~12mm AF (옵션)" },
      { feature: "초점 제어", value: "자동/수동 (네트워크를 통한 원격제어)" },
      { feature: "자동초점 (Auto Exposure)", value: "YES" },
      { feature: "디지털 줌", value: "8x" },
      { feature: "OSD", value: "Off/On" },
      { feature: "Flip/Mirror", value: "Off/On" },
      { feature: "노출(AE)", value: "자동/수동" },
      { feature: "셔터속도", value: "1/10000 ~ 1/30 (sec)" },
      { feature: "자동 조리개", value: "Off/On" },
      { feature: "Auto Flicker-less", value: "Off/On" },
      { feature: "색 온도(AWB)", value: "자동(실내, 실외), 그늘, 쾌청한 하늘, 형광등, 백열등, 불꽃, 수동" },
      { feature: "Day & Night", value: "자동/주간/야간/외부신호" },
      { feature: "WDR, BLC, HLC, DNR", value: "Off/On" },
      { feature: "안개보정(Defog)", value: "Off/On/Auto" },
      { feature: "세로모드", value: "Off/On (90도, 270도)" },
      { feature: "LDC 경계선", value: "Off/On" },
      { feature: "사생활 보호(Privacy Mask)", value: "8개 영역 지정가능" },
      { feature: "움직임 감지(Motion Detection)", value: "4개 Mask, 4개 Detection 지정가능" },
      { feature: "이벤트 감지", value: "부팅감지, 수동 트리거, 네트워크감지" },
      { feature: "이벤트 동작", value: "알람 출력" },
      { feature: "화재감지 기능", value: "Single Flame Sensor (4300nm)" },
      { feature: "야간가시거리", value: "IR SUPER LED: 6개 & Flame Sensor 장착" },
      { feature: "압축방식", value: "H.264/H265(High, Main, Baseline Profile), MJPEG" },
      { feature: "해상도", value: "2592x1944, 1920x1080, 1280x1024, 1280x720, 704x576, 704x480, 640x480, 640x360, 320x240" },
      { feature: "최대 프레임 레이트", value: "최대 30fps@2592x1944" },
      { feature: "압축방식", value: "G.711 ADPCM a-Law/u-Law" },
      { feature: "양방향", value: "입력(option) / 출력(option)" },
      { feature: "입력(option)", value: "1Line-In" },
      { feature: "출력(option)", value: "1Line-Out" },
      { feature: "이더넷", value: "RJ-45(10/100BASE-T)" },
      { feature: "비트 레이트", value: "100 ~ 12000Kbps" },
      { feature: "IP", value: "IPv4, IPv6" },
      { feature: "Protocol", value: "TCP/IP, UDP/IP, RTP, RTSP, HTTP, HTTPS, SMTP, FTP, DHCP, UPnP, Zeroconf, DNS, DDNS" },
      { feature: "보안", value: "HTTPS암호화, 사용자 관리, IP주소 필터링" },
      { feature: "FTP Uploading", value: "MJPEG Still Image" },
      { feature: "최대 동시 접속자", value: "10" },
      { feature: "S/W 응용 인터페이스", value: "Onvif profile S, ..." },
      { feature: "지원 OS", value: "Windows Vista(32bit)/7/8" },
      { feature: "지원 웹브라우저", value: "Micro Internet Explorer Ver.9, 10 Apple Safari Ver.4.0 (Plug-in free viewer only) Google Chrome Ver.4.0 (Plug-in free viewer only)" },
      { feature: "웹 언어", value: "한국어, English, 러시아어, 일본어" },
      { feature: "동작온도/습도", value: "-20°C ~ 50°C / 90% RH 이하" },
      { feature: "방진/방수", value: "IP66" },
      { feature: "조절", value: "3축 조절기능" },
      { feature: "사용전원/소비전류", value: "DC12V, PoE(IEEE802.3af) / 510mA(Max)" },
      { feature: "재질/색상", value: "Aluminum / white / black" },
      { feature: "중량", value: "0.75Kg" },
      { feature: "외형 치수", value: "135PI x 98.9mm(H)" },
      ],
    relatedProducts: [
      { id: "tnc-gb210v12afs", badges: ["Network","GLOBAL SHUTTER","2M"] },
      { id: "tnc-v210v06af", badges: ["Network","IR","2M"] },
      { id: "tnc-v210v06afs", badges: ["Network","IR","2M"] },
      { id: "tnc-v510v06afs", badges: ["Network","IR","5M"] },
    ],
  },
  // TNC-GB210V12AFS
  {
    id: "tnc-gb210v12afs",
    isNew: true,
    model: "TNC-GB210V12AFS",
    category: "special",
    categoryLabel: "Special",
    aiTags: ["object-detection"],
    description: "2M Global Shutter Camera",
    aiSummary: "300만 화소 네트워크 글로벌 셔터 불릿 카메라로, SONY IMX265 글로벌 셔터 센서를 탑재해 움직이는 객체의 왜곡 없이 선명하게 촬영합니다. IP68 등급의 방진방수 성능을 갖추고 있어, 차량 번호판 인식, 교통 관제, 고속 이동 객체 감시 등에 적합합니다.",
    allProductsImageKey: "Special/TNC-GB210V12AFS",
    images: [
      { key: "Special/TNC-GB210V12AFS", isDefault: true },
      { key: "Special/TNC-V210V06AF", isDefault: false },
    ],
    badges: [
      { text: "Network", colorScheme: "green" },
      { text: "Global Shutter", colorScheme: "red" },
      { text: "2M", colorScheme: "blue" },
    ],
    keyFeatures: [
      "300만 화소 네트워크  (30fps)",
      "H.265 / H.264 / MJPEG  Triple 스트리밍 지원",
      "1/1.8” SONY GLOBAL 이미지 센서_IMX265",
      "Built In  AF ZOOM  LENS (3.6~12mm AF)",
      "Built In  AF ZOOM  LENS (12~40mmAF) (옵션)",
      "WDR(Wide Dynamic Range)",
      "DNR(Digital Noise Reduction)",
      "Strove Pulse 고휘도 IR 제어 (730nm)",
      "FAN 내장",
      "IP66",
    ],
    specs: [
      { feature: "유효화소", value: "2064(H) x 1536(V)" },
      { feature: "촬상소자", value: "1/2\" 2.1M Pixels Progressive Exmor Sensor" },
      { feature: "최소거리", value: "100mm~1200mm" },
      { feature: "S/N비", value: "54dB" },
      { feature: "최저조도", value: "0 Lux (IR LED ON)" },
      { feature: "초점 거리", value: "f=3.6mm ~ 12mm AF // 12~40mmAF (OPTION)" },
      { feature: "초점 제어", value: "자동/수동 (네트워크를 통한 원격제어)" },
      { feature: "자동초점 (Auto Exposure)", value: "YES" },
      { feature: "디지털 줌", value: "8x" },
      { feature: "OSD", value: "Off/ON" },
      { feature: "Flip/Mirror", value: "Off/On" },
      { feature: "노출(AE)", value: "자동/수동" },
      { feature: "셔터속도", value: "1/10000 ~ 1/30 (sec)" },
      { feature: "자동 조리개", value: "Off/On" },
      { feature: "Auto Flicker-less", value: "Off/On" },
      { feature: "색 온도(AWB)", value: "자동(실내,실외), 그늘, 쾌청한 하늘, 형광등, 백열등, 불꽃, 수동" },
      { feature: "Day & Night", value: "자동/주간/야간/외부신호" },
      { feature: "WDR,BLC,HLC,DNR", value: "Off/On" },
      { feature: "안개보정(Defog)", value: "Off/On/Auto" },
      { feature: "세로모드", value: "Off/On (90도, 270도)" },
      { feature: "LDC 경계선", value: "Off/On" },
      { feature: "사생활 보호(Privacy Mask)", value: "8개 영역 지정가능" },
      { feature: "움직임 감지(Motion Detection)", value: "4개 Mask, 4개 Detection 지정가능" },
      { feature: "이벤트 감지", value: "알람 입력,부팅감지,수동 트리거,네트워크감지" },
      { feature: "이벤트 동작", value: "알람 출력" },
      { feature: "화면 가림 감지(Temper)", value: "Off/On" },
      { feature: "야간가시거리", value: "30~50m(730nm IR LED : 12개)" },
      { feature: "압축방식", value: "H.264/H265(High, Main ,Baseline Profile), MJPEG" },
      { feature: "해상도", value: "1920x1080, 1280x1024, 1280x720, 704x576, 704x480, 640x480, 640x360, 320x240" },
      { feature: "최대 프레임 레이트", value: "최대 30fps@ 1920x1080" },
      { feature: "압축방식", value: "G.711 ADPCM a-Law/u-Law" },
      { feature: "통신", value: "양방향" },
      { feature: "입력(option)", value: "1Line-In" },
      { feature: "출력(option)", value: "1Line-Out" },
      { feature: "이더넷", value: "RJ-45(10/100BASE-T)" },
      { feature: "비트 레이트", value: "100 ~ 12000Kbps" },
      { feature: "IP", value: "IPv4, IPv6" },
      { feature: "Protocol", value: "TCP/IP,UDP/IP,RTP,RTSP,HTTP,HTTPS,SMTP,FTP,DHCP,UPnP ,Zeroconf, DNS,DDNS" },
      { feature: "보안", value: "HTTPS암호화,사용자 관리, IP주소 필터링" },
      { feature: "FTP Uploading", value: "MJPEG Stil Image" },
      { feature: "최대 동시 접속자", value: "10" },
      { feature: "S/W 응용 인터페이스", value: "Onvif profile S, ..." },
      { feature: "웹 뷰어", value: "지원OS : Windows Vista(32bit)/7/8 지원 웹브라우져 : Micro Internet Explorer Ver.9, 10 Apple Safari Ver.4.0(Plug-in free viewer only) Google Chrome Ver.4.0(Plug-in free viewer only)" },
      { feature: "웹 언어", value: "한국어, English, 러시아어,일본어" },
      { feature: "동작온도/습도", value: "-20°C ~ 50°C / 90% RH 이하" },
      { feature: "방진/방수", value: "IP68" },
      { feature: "조절", value: "Y" },
      { feature: "사용전원/소비전류", value: "DC12V, PoE(IEEE802.3af) / 510mA(Max)" },
      { feature: "재질/색상", value: "Aluminum / white/black" },
      { feature: "중량", value: "1.5 Kg" },
      { feature: "외형 치수", value: "108(W) X 370.1(L) X106.3(H)" },
      ],
    relatedProducts: [
      { id: "tnc-v210v06af", badges: ["Network","IR","2M"] },
      { id: "tnc-v210v06afs", badges: ["Network","IR","2M"] },
      { id: "tnc-v510v06afs", badges: ["Network","IR","5M"] },
      { id: "tnc-ef528af", badges: ["Network","IR","5M","Fire Alarm"] },
    ],
  },
  // TNC-V210V06AF
  {
    id: "tnc-v210v06af",
    model: "TNC-V210V06AF",
    category: "special",
    categoryLabel: "Special",
    description: "2M Eyeball Camera",
    aiSummary: "200만 화소 네트워크 아이볼 카메라로, 4배율 자동초점 줌 렌즈를 탑재한 소형 감시 카메라입니다. IP66 방진방수로 야외 설치가 가능하며, 가볍고 컴팩트한 디자인으로 주택, 소형 상가 등 소규모 감시에 적합합니다.",
    allProductsImageKey: "Special/TNC-V210V06AF",
    images: [
      { key: "Special/TNC-GB210V12AFS", isDefault: false },
      { key: "Special/TNC-V210V06AF", isDefault: true },
    ],
    badges: [
      { text: "Network", colorScheme: "green" },
      { text: "Eyeball", colorScheme: "red" },
      { text: "2M", colorScheme: "blue" },
    ],
    keyFeatures: [
      "200만 화소 네트워크 PTZ 카메라(1920x1080P @ 30fps)",
      "H.265 / H.264 / MJPEG  Triple 스트리밍 지원",
      "1/2.8” SONY CMOS 이미지 센서",
      "Built In X4  AF ZOOM  LENS (2.8~12mmAF)",
      "WDR(Wide Dynamic Range)",
      "DNR(Digital Noise Reduction)",
      "움직임 감지 기능",
      "FAN 내장",
      "IP66",
    ],
    specs: [
      { feature: "유효화소", value: "1920(H) x 1080(V) (Full-HD)" },
      { feature: "촬상소자", value: "1/2.8 \" 2.1M Pixels Progressive Exmor Sensor" },
      { feature: "최소거리", value: "100mm~1200mm" },
      { feature: "S/N비", value: "54dB" },
      { feature: "최저조도", value: "0 Lux (IR LED ON)" },
      { feature: "초점 거리", value: "2.8 ~ 12mm Auto Focus" },
      { feature: "초점 제어", value: "자동/수동 (네트워크를 통한 원격제어)" },
      { feature: "자동초점 (Auto Exposure)", value: "YES" },
      { feature: "디지털 줌", value: "8x" },
      { feature: "OSD", value: "Off/ON" },
      { feature: "Flip/Mirror", value: "Off/On" },
      { feature: "노출(AE)", value: "자동/수동" },
      { feature: "셔터속도", value: "1/10000 ~ 1/30 (sec)" },
      { feature: "자동 조리개", value: "Off/On" },
      { feature: "Auto Flicker-less", value: "Off/On" },
      { feature: "색 온도(AWB)", value: "자동(실내,실외), 그늘, 쾌청한 하늘, 형광등, 백열등, 불꽃, 수동" },
      { feature: "Day & Night", value: "자동/주간/야간/외부신호" },
      { feature: "WDR,BLC,HLC,DNR", value: "Off/On" },
      { feature: "안개보정(Defog)", value: "Off/On/Auto" },
      { feature: "세로모드", value: "Off/On (90도, 270도)" },
      { feature: "LDC 경계선", value: "Off/On" },
      { feature: "사생활 보호(Privacy Mask)", value: "8개 영역 지정가능" },
      { feature: "움직임 감지(Motion Detection)", value: "4개 Mask, 4개 Detection 지정가능" },
      { feature: "이벤트 감지", value: "알람 입력,부팅감지,수동 트리거,네트워크감지" },
      { feature: "이벤트 동작", value: "알람 출력" },
      { feature: "화면 가림 감지(Temper)", value: "Off/On" },
      { feature: "야간가시거리", value: "10~20m (IR LED : 6개)" },
      { feature: "압축방식", value: "H.264/H265(High, Main ,Baseline Profile), MJPEG" },
      { feature: "해상도", value: "1920x1080, 1280x1024, 1280x720, 704x576, 704x480, 640x480, 640x360, 320x240" },
      { feature: "최대 프레임 레이트", value: "최대 30fps@ 1920x1080" },
      { feature: "압축방식", value: "G.711 ADPCM a-Law/u-Law" },
      { feature: "통신", value: "양방향" },
      { feature: "입력(option)", value: "1Line-In" },
      { feature: "출력(option)", value: "1Line-Out" },
      { feature: "이더넷", value: "RJ-45(10/100BASE-T)" },
      { feature: "비트 레이트", value: "100 ~ 12000Kbps" },
      { feature: "IP", value: "IPv4, IPv6" },
      { feature: "Protocol", value: "TCP/IP,UDP/IP,RTP,RTSP,HTTP,HTTPS,SMTP,FTP,DHCP,UPnP ,Zeroconf, DNS,DDNS" },
      { feature: "보안", value: "HTTPS암호화,사용자 관리, IP주소 필터링" },
      { feature: "FTP Uploading", value: "MJPEG Stil Image" },
      { feature: "최대 동시 접속자", value: "10" },
      { feature: "S/W 응용 인터페이스", value: "Onvif profile S, ..." },
      { feature: "웹 뷰어", value: "지원OS : Windows Vista(32bit)/7/8 지원 웹브라우져 : Micro Internet Explorer Ver.9, 10 Apple Safari Ver.4.0(Plug-in free viewer only) Google Chrome Ver.4.0(Plug-in free viewer only)" },
      { feature: "웹 언어", value: "한국어, English, 러시아어,일본어" },
      { feature: "동작온도/습도", value: "-20°C ~ 50°C / 90% RH 이하" },
      { feature: "방진/방수", value: "IP66" },
      { feature: "조절", value: "3축 조절기능" },
      { feature: "사용전원/소비전류", value: "DC12V, PoE(IEEE802.3af) / 510mA(Max)" },
      { feature: "재질/색상", value: "Aluminum / white/black" },
      { feature: "중량", value: "0.75Kg" },
      { feature: "외형 치수", value: "135PI x 98.9mm(H)" },
      ],
    relatedProducts: [
      { id: "tnc-gb210v12afs", badges: ["Network","GLOBAL SHUTTER","2M"] },
      { id: "tnc-v210v06afs", badges: ["Network","IR","2M"] },
      { id: "tnc-v510v06afs", badges: ["Network","IR","5M"] },
      { id: "tnc-ef528af", badges: ["Network","IR","5M","Fire Alarm"] },
    ],
  },
  // TNC-V210V06AFS
  {
    id: "tnc-v210v06afs",
    model: "TNC-V210V06AFS",
    category: "special",
    categoryLabel: "Special",
    description: "2M Eyeball Camera",
    aiSummary: "200만 화소 네트워크 아이볼 카메라로, SONY IMX385 센서 기반 최대 60fps의 부드러운 영상을 제공합니다. 자동초점 줌 렌즈와 양방향 오디오를 지원하며, 소형이면서도 풍부한 기능이 필요한 소규모 실내외 감시에 적합합니다.",
    allProductsImageKey: "Special/TNC-V210V06AF",
    images: [
      { key: "Special/TNC-GB210V12AFS", isDefault: false },
      { key: "Special/TNC-V210V06AF", isDefault: true },
    ],
    badges: [
      { text: "Network", colorScheme: "green" },
      { text: "Eyeball", colorScheme: "red" },
      { text: "2M", colorScheme: "blue" },
    ],
    keyFeatures: [
      "200만 화소 네트워크 PTZ 카메라(1920x1080P @ 60fps)",
      "H.265 / H.264 / MJPEG  Triple 스트리밍 지원",
      "1/2” SONY CMOS 이미지 센서_IMX385",
      "Built In X4  AF ZOOM  LENS (3.6~12mmAF)",
      "WDR(Wide Dynamic Range)",
      "DNR(Digital Noise Reduction)",
      "움직임 감지 기능",
      "양 뱡향 오디오 지원 ALARM IN & OUT",
      "FAN 내장",
      "IP66",
    ],
    specs: [
      { feature: "유효화소", value: "1920(H) x 1080(V) (Full-HD)" },
      { feature: "촬상소자", value: "1/2\" 2.1M Pixels Progressive Exmor Sensor" },
      { feature: "최소거리", value: "100mm~1200mm" },
      { feature: "S/N비", value: "54dB" },
      { feature: "최저조도", value: "0 Lux (IR LED ON)" },
      { feature: "초점 거리", value: "3.6 ~ 12mm Auto Focus" },
      { feature: "초점 제어", value: "자동/수동 (네트워크를 통한 원격제어)" },
      { feature: "자동초점 (Auto Exposure)", value: "YES" },
      { feature: "디지털 줌", value: "8x" },
      { feature: "OSD", value: "Off/ON" },
      { feature: "Flip/Mirror", value: "Off/On" },
      { feature: "노출(AE)", value: "자동/수동" },
      { feature: "셔터속도", value: "1/10000 ~ 1/30 (sec)" },
      { feature: "자동 조리개", value: "Off/On" },
      { feature: "Auto Flicker-less", value: "Off/On" },
      { feature: "색 온도(AWB)", value: "자동(실내,실외), 그늘, 쾌청한 하늘, 형광등, 백열등, 불꽃, 수동" },
      { feature: "Day & Night", value: "자동/주간/야간/외부신호" },
      { feature: "WDR,BLC,HLC,DNR", value: "Off/On" },
      { feature: "안개보정(Defog)", value: "Off/On/Auto" },
      { feature: "세로모드", value: "Off/On (90도, 270도)" },
      { feature: "LDC 경계선", value: "Off/On" },
      { feature: "사생활 보호(Privacy Mask)", value: "8개 영역 지정가능" },
      { feature: "움직임 감지(Motion Detection)", value: "4개 Mask, 4개 Detection 지정가능" },
      { feature: "이벤트 감지", value: "알람 입력,부팅감지,수동 트리거,네트워크감지" },
      { feature: "이벤트 동작", value: "알람 출력" },
      { feature: "화면 가림 감지(Temper)", value: "Off/On" },
      { feature: "야간가시거리", value: "10~20m(IR LED : 6개)" },
      { feature: "압축방식", value: "H.264/H265(High, Main ,Baseline Profile), MJPEG" },
      { feature: "해상도", value: "1920x1080, 1280x1024, 1280x720, 704x576, 704x480, 640x480, 640x360, 320x240" },
      { feature: "최대 프레임 레이트", value: "최대 60fps@ 1920x1080" },
      { feature: "압축방식", value: "G.711 ADPCM a-Law/u-Law" },
      { feature: "통신", value: "양방향" },
      { feature: "입력(option)", value: "1Line-In" },
      { feature: "출력(option)", value: "1Line-Out" },
      { feature: "이더넷", value: "RJ-45(10/100BASE-T)" },
      { feature: "비트 레이트", value: "100 ~ 12000Kbps" },
      { feature: "IP", value: "IPv4, IPv6" },
      { feature: "Protocol", value: "TCP/IP,UDP/IP,RTP,RTSP,HTTP,HTTPS,SMTP,FTP,DHCP,UPnP ,Zeroconf, DNS,DDNS" },
      { feature: "보안", value: "HTTPS암호화,사용자 관리, IP주소 필터링" },
      { feature: "FTP Uploading", value: "MJPEG Stil Image" },
      { feature: "최대 동시 접속자", value: "10" },
      { feature: "S/W 응용 인터페이스", value: "Onvif profile S, ..." },
      { feature: "웹 뷰어", value: "지원OS : Windows Vista(32bit)/7/8 지원 웹브라우져 : Micro Internet Explorer Ver.9, 10 Apple Safari Ver.4.0(Plug-in free viewer only) Google Chrome Ver.4.0(Plug-in free viewer only)" },
      { feature: "웹 언어", value: "한국어, English, 러시아어,일본어" },
      { feature: "동작온도/습도", value: "-20°C ~ 50°C / 90% RH 이하" },
      { feature: "방진/방수", value: "IP66" },
      { feature: "조절", value: "3축 조절기능" },
      { feature: "사용전원/소비전류", value: "DC12V, PoE(IEEE802.3af) / 510mA(Max)" },
      { feature: "재질/색상", value: "Aluminum / white/black" },
      { feature: "중량", value: "0.75Kg" },
      { feature: "외형 치수", value: "135PI x 98.9mm(H)" },
      ],
    relatedProducts: [
      { id: "tnc-gb210v12afs", badges: ["Network","GLOBAL SHUTTER","2M"] },
      { id: "tnc-v210v06af", badges: ["Network","IR","2M"] },
      { id: "tnc-v510v06afs", badges: ["Network","IR","5M"] },
      { id: "tnc-ef528af", badges: ["Network","IR","5M","Fire Alarm"] },
    ],
  },
  // TNC-V510V06AFS
  {
    id: "tnc-v510v06afs",
    isNew: true,
    model: "TNC-V510V06AFS",
    category: "special",
    categoryLabel: "Special",
    description: "5M Eyeball Camera",
    aiSummary: "500만 화소 네트워크 아이볼 카메라로, 5배율 자동초점 줌 렌즈를 탑재한 고해상도 소형 감시 카메라입니다. 양방향 오디오, IP66 방진방수를 지원하며, 고해상도와 컴팩트한 크기가 동시에 필요한 소규모 감시 구역에 적합합니다.",
    allProductsImageKey: "Special/TNC-V210V06AF",
    images: [
      { key: "Special/TNC-GB210V12AFS", isDefault: false },
      { key: "Special/TNC-V210V06AF", isDefault: true },
    ],
    badges: [
      { text: "Network", colorScheme: "green" },
      { text: "Eyeball", colorScheme: "red" },
      { text: "5M", colorScheme: "blue" },
    ],
    keyFeatures: [
      "500만 화소 네트워크 PTZ 카메라(2592x1944P @ 30fps)",
      "H.265 / H.264 / MJPEG  Triple 스트리밍 지원",
      "1/2.8” SONY CMOS 이미지 센서_IMX335",
      "Built In X5 AF ZOOM  LENS (2.7~13.5mmAF)",
      "WDR(Wide Dynamic Range)",
      "DNR(Digital Noise Reduction)",
      "움직임 감지 기능",
      "양 뱡향 오디오 지원 ALARM IN & OUT",
      "FAN 내장",
      "IP66",
    ],
    specs: [
      { feature: "유효화소", value: "2592(H) x 1944(V) (Full-HD)" },
      { feature: "촬상소자", value: "1/2.8\" 5M Pixels Progressive Exmor Sensor" },
      { feature: "최소거리", value: "100mm~1200mm" },
      { feature: "S/N비", value: "54dB" },
      { feature: "최저조도", value: "0 Lux (IR LED ON)" },
      { feature: "초점 거리", value: "2.7 ~ 13.5mm Auto Focus" },
      { feature: "초점 제어", value: "자동/수동 (네트워크를 통한 원격제어)" },
      { feature: "자동초점 (Auto Exposure)", value: "YES" },
      { feature: "디지털 줌", value: "8x" },
      { feature: "OSD", value: "Off/ON" },
      { feature: "Flip/Mirror", value: "Off/On" },
      { feature: "노출(AE)", value: "자동/수동" },
      { feature: "셔터속도", value: "1/10000 ~ 1/30 (sec)" },
      { feature: "자동 조리개", value: "Off/On" },
      { feature: "Auto Flicker-less", value: "Off/On" },
      { feature: "색 온도(AWB)", value: "자동(실내,실외), 그늘, 쾌청한 하늘, 형광등, 백열등, 불꽃, 수동" },
      { feature: "Day & Night", value: "자동/주간/야간/외부신호" },
      { feature: "WDR,BLC,HLC,DNR", value: "Off/On" },
      { feature: "안개보정(Defog)", value: "Off/On/Auto" },
      { feature: "세로모드", value: "Off/On (90도, 270도)" },
      { feature: "LDC 경계선", value: "Off/On" },
      { feature: "사생활 보호(Privacy Mask)", value: "8개 영역 지정가능" },
      { feature: "움직임 감지(Motion Detection)", value: "4개 Mask, 4개 Detection 지정가능" },
      { feature: "이벤트 감지", value: "알람 입력,부팅감지,수동 트리거,네트워크감지" },
      { feature: "이벤트 동작", value: "알람 출력" },
      { feature: "화면 가림 감지(Temper)", value: "Off/On" },
      { feature: "야간가시거리", value: "10~20m(IR LED : 6개)" },
      { feature: "압축방식", value: "H.264/H265(High, Main ,Baseline Profile), MJPEG" },
      { feature: "해상도", value: "2592X1944,1920x1080, 1280x1024, 1280x720, 704x576, 704x480, 640x480, 640x360, 320x240" },
      { feature: "최대 프레임 레이트", value: "최대 30fps@ 2592x1944" },
      { feature: "압축방식", value: "G.711 ADPCM a-Law/u-Law" },
      { feature: "통신", value: "양방향" },
      { feature: "입력(option)", value: "1Line-In" },
      { feature: "출력(option)", value: "1Line-Out" },
      { feature: "이더넷", value: "RJ-45(10/100BASE-T)" },
      { feature: "비트 레이트", value: "100 ~ 12000Kbps" },
      { feature: "IP", value: "IPv4, IPv6" },
      { feature: "Protocol", value: "TCP/IP,UDP/IP,RTP,RTSP,HTTP,HTTPS,SMTP,FTP,DHCP,UPnP ,Zeroconf, DNS,DDNS" },
      { feature: "보안", value: "HTTPS암호화,사용자 관리, IP주소 필터링" },
      { feature: "FTP Uploading", value: "MJPEG Stil Image" },
      { feature: "최대 동시 접속자", value: "10" },
      { feature: "S/W 응용 인터페이스", value: "Onvif profile S, ..." },
      { feature: "웹 뷰어", value: "지원OS : Windows Vista(32bit)/7/8 지원 웹브라우져 : Micro Internet Explorer Ver.9, 10 Apple Safari Ver.4.0(Plug-in free viewer only) Google Chrome Ver.4.0(Plug-in free viewer only)" },
      { feature: "웹 언어", value: "한국어, English, 러시아어,일본어" },
      { feature: "동작온도/습도", value: "-20°C ~ 50°C / 90% RH 이하" },
      { feature: "방진/방수", value: "IP66" },
      { feature: "조절", value: "3축 조절기능" },
      { feature: "사용전원/소비전류", value: "DC12V, PoE(IEEE802.3af) / 510mA(Max)" },
      { feature: "재질/색상", value: "Aluminum / white/black" },
      { feature: "중량", value: "0.75Kg" },
      { feature: "외 형 치 수", value: "135PI x 98.9mm(H)" },
      ],
    relatedProducts: [
      { id: "tnc-gb210v12afs", badges: ["Network","GLOBAL SHUTTER","2M"] },
      { id: "tnc-v210v06af", badges: ["Network","IR","2M"] },
      { id: "tnc-v210v06afs", badges: ["Network","IR","2M"] },
      { id: "tnc-ef528af", badges: ["Network","IR","5M","Fire Alarm"] },
    ],
  },
];

// Product display order for AllProducts page
export const allProductsOrder = [
  "tnc-bf228afs",
  "tnc-bf528af",
  "tnc-ef528af",
  "tnc-bz236v12af",
  "tnc-bz204v12afs",
  "tnc-b210v12afs",
  "tnc-b510v12af",
  "tnc-b120v12afs",
  "utc-8060r",
  "tnc-fv120f",
  "tnc-v210f18",
  "tnc-d210v21af",
  "tnc-d210v21afs",
  "tnc-d210v30afs",
  "tnc-d510v21af",
  "utc-800dr",
  "tnc-bp516afs",
  "tnc-bp21v36afs",
  "tnc-bp21v08afs",
  "tnc-vs210af",
  "tnc-vs210afs",
  "tnc-vs510afs",
  "tnc-gb210v12afs",
  "tnc-v210v06af",
  "tnc-v210v06afs",
  "tnc-v510v06afs",
  "tnc-sd438afs",
  "tnc-sd838afs",
];

// Home page "new products" rail, most recent first.
export const newProductsOrder = [
  "tnc-bf228afs",
  "tnc-bf528af",
  "tnc-ef528af",
  "tnc-sd438afs",
  "tnc-sd838afs",
  "tnc-vs510afs",
  "tnc-d510v21af",
  "tnc-b510v12af",
  "tnc-bp516afs",
  "tnc-bp21v36afs",
  "tnc-fv120f",
  "tnc-b120v12afs",
  "tnc-v510v06afs",
  "tnc-gb210v12afs",
];

export { products };
export default products;
